const types = {
  suite: {
    "suite@pro/edge/suite": {
      libName: "suite_9.1",
      basePath: "suite/pro/9.1",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-all/sources/entry_pro.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Export.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/ProChart.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/CalendarHeatMap.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/series/TreeMap.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/input.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/locale.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/group.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/methods.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/avatar.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/fieldset.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/elements/ToggleButton.d.ts",
        "types/ts-form/sources/elements/ToggleGroup.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/ExtendedGrid.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/default.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/locales/en.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/common.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/group/panel.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-grid/sources/ui/SubRows.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-pagination/index.d.ts",
        "types/ts-pagination/sources/Pagination.d.ts",
        "types/ts-pagination/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/ProRibbon.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/ProSidebar.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts"
      ],
    },
    "suite@/edge/suite": {
      libName: "suite_9.1",
      basePath: "suite/9.1",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-all/sources/entry_pro.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Export.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/ProChart.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/CalendarHeatMap.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/series/TreeMap.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/input.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/locale.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/group.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/methods.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/avatar.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/fieldset.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/elements/ToggleButton.d.ts",
        "types/ts-form/sources/elements/ToggleGroup.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/ExtendedGrid.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/default.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/locales/en.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/common.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/group/panel.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-grid/sources/ui/SubRows.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-pagination/index.d.ts",
        "types/ts-pagination/sources/Pagination.d.ts",
        "types/ts-pagination/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/ProRibbon.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/ProSidebar.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts"
      ],
    },
    "suite@pro/9.1/suite": {
      libName: "suite_9.1",
      basePath: "suite/pro/9.1",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-all/sources/entry_pro.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Export.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/ProChart.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/CalendarHeatMap.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/series/TreeMap.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/input.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/locale.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/group.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/methods.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/avatar.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/fieldset.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/elements/ToggleButton.d.ts",
        "types/ts-form/sources/elements/ToggleGroup.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/ExtendedGrid.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/default.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/locales/en.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/common.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/group/panel.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-grid/sources/ui/SubRows.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-pagination/index.d.ts",
        "types/ts-pagination/sources/Pagination.d.ts",
        "types/ts-pagination/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/ProRibbon.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/ProSidebar.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts"
      ],
    },
    "suite@/9.1//suite": {
      libName: "suite_9.1",
      basePath: "suite/9.1",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-all/sources/entry_pro.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Export.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/ProChart.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/CalendarHeatMap.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/series/TreeMap.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/input.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/locale.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/group.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/methods.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/avatar.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/fieldset.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/elements/ToggleButton.d.ts",
        "types/ts-form/sources/elements/ToggleGroup.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/ExtendedGrid.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/default.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/locales/en.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/common.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/group/panel.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-grid/sources/ui/SubRows.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-pagination/index.d.ts",
        "types/ts-pagination/sources/Pagination.d.ts",
        "types/ts-pagination/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/ProRibbon.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/ProSidebar.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts"
      ],
    },
    "suite@pro/9.0/suite": {
      libName: "suite_9.0",
      basePath: "suite/pro/9.0",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-all/sources/entry_pro.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Export.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/ProChart.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/CalendarHeatMap.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/series/TreeMap.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/input.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/locale.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/group.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/methods.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/avatar.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/fieldset.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/elements/ToggleButton.d.ts",
        "types/ts-form/sources/elements/ToggleGroup.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/ExtendedGrid.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/default.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/locales/en.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/common.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/group/panel.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-pagination/index.d.ts",
        "types/ts-pagination/sources/Pagination.d.ts",
        "types/ts-pagination/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/ProRibbon.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/ProSidebar.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts"
      ],
    },
    "suite@/9.0/suite": {
      libName: "suite_9.0",
      basePath: "suite/9.0",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-all/sources/entry_pro.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Export.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/ProChart.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/CalendarHeatMap.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/series/TreeMap.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/input.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/locale.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/group.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/methods.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/avatar.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/fieldset.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/elements/ToggleButton.d.ts",
        "types/ts-form/sources/elements/ToggleGroup.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/ExtendedGrid.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/default.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/locales/en.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/common.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/group/panel.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-pagination/index.d.ts",
        "types/ts-pagination/sources/Pagination.d.ts",
        "types/ts-pagination/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/ProRibbon.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/ProSidebar.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts"
      ],
    },
    "suite@pro/8.4/suite": {
      libName: "suite_8.4",
      basePath: "suite/pro/8.4",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-all/sources/entry_pro.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Export.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/ProChart.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/CalendarHeatMap.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/series/TreeMap.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/locale.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/avatar.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/fieldset.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/elements/ToggleButton.d.ts",
        "types/ts-form/sources/elements/ToggleGroup.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-pagination/index.d.ts",
        "types/ts-pagination/sources/Pagination.d.ts",
        "types/ts-pagination/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/ProRibbon.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/ProSidebar.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts"
      ],
    },
    "suite@/8.4/suite": {
      libName: "suite_8.4",
      basePath: "suite/8.4",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-all/sources/entry_pro.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Export.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/ProChart.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/CalendarHeatMap.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/series/TreeMap.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/locale.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/avatar.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/fieldset.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/elements/ToggleButton.d.ts",
        "types/ts-form/sources/elements/ToggleGroup.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-pagination/index.d.ts",
        "types/ts-pagination/sources/Pagination.d.ts",
        "types/ts-pagination/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/ProRibbon.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/ProSidebar.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts"
      ],
    },
    "suite@pro/8.3/suite": {
      libName: "suite_8.3",
      basePath: "suite/pro/8.3",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-all/sources/entry_pro.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/entry.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-calendar/tests/calendar/calendar.d.ts",
        "types/ts-calendar/tests/suite.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/entry.d.ts",
        "types/ts-chart/sources/entry_pro.d.ts",
        "types/ts-chart/sources/Export.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/ProChart.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/CalendarHeatMap.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/series/TreeMap.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-chart/tests/Chart.d.ts",
        "types/ts-chart/tests/suite.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/entry.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-colorpicker/tests/suite.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/entry.d.ts",
        "types/ts-combobox/sources/entry_pro.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-combobox/tests/suite.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/tests/core.d.ts",
        "types/ts-common/tests/events.d.ts",
        "types/ts-common/tests/html.d.ts",
        "types/ts-common/tests/suite.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/entry.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-data/tests/ajax.d.ts",
        "types/ts-data/tests/drivers.d.ts",
        "types/ts-data/tests/filter.d.ts",
        "types/ts-data/tests/main.d.ts",
        "types/ts-data/tests/move.d.ts",
        "types/ts-data/tests/sort.d.ts",
        "types/ts-data/tests/suite.d.ts",
        "types/ts-data/tests/treecollection.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/entry.d.ts",
        "types/ts-dataview/sources/entry_pro.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-dataview/tests/selections/Selections.d.ts",
        "types/ts-dataview/tests/selections/stubs.d.ts",
        "types/ts-dataview/tests/suite.d.ts",
        "types/ts-diagram/index.d.ts",
        "types/ts-diagram/sources/Diagram.d.ts",
        "types/ts-diagram/sources/entry.d.ts",
        "types/ts-diagram/sources/helpers/Export.d.ts",
        "types/ts-diagram/sources/helpers/linkPaths.d.ts",
        "types/ts-diagram/sources/helpers/placement.d.ts",
        "types/ts-diagram/sources/helpers/Selection.d.ts",
        "types/ts-diagram/sources/locales/en.d.ts",
        "types/ts-diagram/sources/shapes/Base.d.ts",
        "types/ts-diagram/sources/shapes/Connector/Line.d.ts",
        "types/ts-diagram/sources/shapes/Diagram/DiagramCard.d.ts",
        "types/ts-diagram/sources/shapes/Diagram/DiagramImgCard.d.ts",
        "types/ts-diagram/sources/shapes/Diagram/DiagramSvgCard.d.ts",
        "types/ts-diagram/sources/shapes/Diagram/templates.d.ts",
        "types/ts-diagram/sources/shapes/factory.d.ts",
        "types/ts-diagram/sources/shapes/FlowShape.d.ts",
        "types/ts-diagram/sources/shapes/TextShape.d.ts",
        "types/ts-diagram/sources/ShapesCollection.d.ts",
        "types/ts-diagram/sources/Toolbar.d.ts",
        "types/ts-diagram/sources/types.d.ts",
        "types/ts-diagram/tests/stubs.d.ts",
        "types/ts-diagram/tests/suite.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/avatar.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/fieldset.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/proCombo.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/elements/ToggleButton.d.ts",
        "types/ts-form/sources/elements/ToggleGroup.d.ts",
        "types/ts-form/sources/entry.d.ts",
        "types/ts-form/sources/entry_pro.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-form/tests/elements/button.d.ts",
        "types/ts-form/tests/elements/checkbox.d.ts",
        "types/ts-form/tests/elements/colorpicker.d.ts",
        "types/ts-form/tests/elements/combo.d.ts",
        "types/ts-form/tests/elements/container.d.ts",
        "types/ts-form/tests/elements/datepicker.d.ts",
        "types/ts-form/tests/elements/input.d.ts",
        "types/ts-form/tests/elements/radiogroup.d.ts",
        "types/ts-form/tests/elements/select.d.ts",
        "types/ts-form/tests/elements/simplevault.d.ts",
        "types/ts-form/tests/elements/slider.d.ts",
        "types/ts-form/tests/elements/textarea.d.ts",
        "types/ts-form/tests/elements/timepicker.d.ts",
        "types/ts-form/tests/form.d.ts",
        "types/ts-form/tests/stubs/stubs.d.ts",
        "types/ts-form/tests/stubs/stubsCheckbox.d.ts",
        "types/ts-form/tests/stubs/stubsColorpicker.d.ts",
        "types/ts-form/tests/stubs/stubsCombo.d.ts",
        "types/ts-form/tests/stubs/stubsDatepicker.d.ts",
        "types/ts-form/tests/stubs/stubsInput.d.ts",
        "types/ts-form/tests/stubs/stubsRadiogroup.d.ts",
        "types/ts-form/tests/stubs/stubsSelect.d.ts",
        "types/ts-form/tests/stubs/stubsSlider.d.ts",
        "types/ts-form/tests/stubs/stubsTimepicker.d.ts",
        "types/ts-form/tests/suite.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/entry.d.ts",
        "types/ts-grid/sources/entry_pro.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-grid/tests/Grid.d.ts",
        "types/ts-grid/tests/stubs.d.ts",
        "types/ts-grid/tests/suite.d.ts",
        "types/ts-grid/tests/TreeGrid.d.ts",
        "types/ts-helpers/entry.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/entry.d.ts",
        "types/ts-layout/sources/entry_pro.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-layout/tests/Layout.d.ts",
        "types/ts-layout/tests/suite.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/entry.d.ts",
        "types/ts-list/sources/entry_pro.d.ts",
        "types/ts-list/sources/helpers.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-list/tests/selections/Selections.d.ts",
        "types/ts-list/tests/selections/stubs.d.ts",
        "types/ts-list/tests/suite.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/entry.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-menu/tests/suite.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/entry.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-message/tests/suite.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-navbar/tests/suite.d.ts",
        "types/ts-optimus/index.d.ts",
        "types/ts-optimus/sources/DHXApp.d.ts",
        "types/ts-optimus/sources/DHXView.d.ts",
        "types/ts-optimus/sources/EventSystem.d.ts",
        "types/ts-optimus/sources/HTMLCell.d.ts",
        "types/ts-optimus/sources/LocalSession.d.ts",
        "types/ts-optimus/sources/types.d.ts",
        "types/ts-pagination/index.d.ts",
        "types/ts-pagination/sources/entry.d.ts",
        "types/ts-pagination/sources/Pagination.d.ts",
        "types/ts-pagination/sources/types.d.ts",
        "types/ts-pagination/tests/suite.d.ts",
        "types/ts-pivot/index.d.ts",
        "types/ts-pivot/sources/configurator/Configurator.d.ts",
        "types/ts-pivot/sources/DataPreprocessor.d.ts",
        "types/ts-pivot/sources/DateFormatter.d.ts",
        "types/ts-pivot/sources/entry.d.ts",
        "types/ts-pivot/sources/filters/DateFilter.d.ts",
        "types/ts-pivot/sources/filters/Filter.d.ts",
        "types/ts-pivot/sources/filters/Filters.d.ts",
        "types/ts-pivot/sources/filters/helpers.d.ts",
        "types/ts-pivot/sources/group-module/DataGroup.d.ts",
        "types/ts-pivot/sources/group-module/groupfuncs.d.ts",
        "types/ts-pivot/sources/group-module/types.d.ts",
        "types/ts-pivot/sources/helpers.d.ts",
        "types/ts-pivot/sources/locales/en.d.ts",
        "types/ts-pivot/sources/Pivot.d.ts",
        "types/ts-pivot/sources/templates.d.ts",
        "types/ts-pivot/sources/types.d.ts",
        "types/ts-pivot/tests/config-module/Config.d.ts",
        "types/ts-pivot/tests/config-module/stubs.d.ts",
        "types/ts-pivot/tests/DataPreprocessor.d.ts",
        "types/ts-pivot/tests/filter-module/Filter.d.ts",
        "types/ts-pivot/tests/group-module/DataGroup.d.ts",
        "types/ts-pivot/tests/group-module/groupfuncs.d.ts",
        "types/ts-pivot/tests/group-module/stubs.d.ts",
        "types/ts-pivot/tests/Pivot.d.ts",
        "types/ts-pivot/tests/stubs.d.ts",
        "types/ts-pivot/tests/suite.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/entry.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-popup/tests/suite.d.ts",
        "types/ts-property/index.d.ts",
        "types/ts-property/sources/entry.d.ts",
        "types/ts-property/sources/items/BaseItem.d.ts",
        "types/ts-property/sources/items/Checkbox.d.ts",
        "types/ts-property/sources/items/Colorpicker.d.ts",
        "types/ts-property/sources/items/Combo.d.ts",
        "types/ts-property/sources/items/helpers.d.ts",
        "types/ts-property/sources/items/index.d.ts",
        "types/ts-property/sources/items/Label.d.ts",
        "types/ts-property/sources/items/Select.d.ts",
        "types/ts-property/sources/items/Text.d.ts",
        "types/ts-property/sources/items/Textarea.d.ts",
        "types/ts-property/sources/Property.d.ts",
        "types/ts-property/sources/types.d.ts",
        "types/ts-property/tests/suite.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/entry.d.ts",
        "types/ts-ribbon/sources/entry_pro.d.ts",
        "types/ts-ribbon/sources/ProRibbon.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-ribbon/tests/suite.d.ts",
        "types/ts-richtext/index.d.ts",
        "types/ts-richtext/sources/constants.d.ts",
        "types/ts-richtext/sources/entry.d.ts",
        "types/ts-richtext/sources/helpers/buffer.d.ts",
        "types/ts-richtext/sources/helpers/composition.d.ts",
        "types/ts-richtext/sources/helpers/link.d.ts",
        "types/ts-richtext/sources/helpers/markdown.d.ts",
        "types/ts-richtext/sources/helpers/minimizer.d.ts",
        "types/ts-richtext/sources/helpers/other.d.ts",
        "types/ts-richtext/sources/helpers/parser.d.ts",
        "types/ts-richtext/sources/helpers/scroll.d.ts",
        "types/ts-richtext/sources/helpers/selection.d.ts",
        "types/ts-richtext/sources/helpers/serializer.d.ts",
        "types/ts-richtext/sources/helpers/statistics.d.ts",
        "types/ts-richtext/sources/helpers/styles.d.ts",
        "types/ts-richtext/sources/helpers/toolbar.d.ts",
        "types/ts-richtext/sources/keyhandler.d.ts",
        "types/ts-richtext/sources/locales/en.d.ts",
        "types/ts-richtext/sources/Manager.d.ts",
        "types/ts-richtext/sources/models/Block.d.ts",
        "types/ts-richtext/sources/models/Editor.d.ts",
        "types/ts-richtext/sources/models/TextNode.d.ts",
        "types/ts-richtext/sources/Richtext.d.ts",
        "types/ts-richtext/sources/SelectionHelper.d.ts",
        "types/ts-richtext/sources/types.d.ts",
        "types/ts-richtext/tests/block.d.ts",
        "types/ts-richtext/tests/editor.d.ts",
        "types/ts-richtext/tests/suite.d.ts",
        "types/ts-richtext/tests/textnode.d.ts",
        "types/ts-samplegen/index.d.ts",
        "types/ts-samplegen/sources/entry.d.ts",
        "types/ts-samplegen/sources/SampleGenerator.d.ts",
        "types/ts-samplegen/tests/suite.d.ts",
        "types/ts-scheduler/index.d.ts",
        "types/ts-scheduler/sources/entry.d.ts",
        "types/ts-scheduler/sources/helpers/scales.d.ts",
        "types/ts-scheduler/sources/helpers/topbar.d.ts",
        "types/ts-scheduler/sources/Scheduler.d.ts",
        "types/ts-scheduler/sources/views/Agenda.d.ts",
        "types/ts-scheduler/sources/views/Base.d.ts",
        "types/ts-scheduler/sources/views/Cols.d.ts",
        "types/ts-scheduler/sources/views/Day.d.ts",
        "types/ts-scheduler/sources/views/index.d.ts",
        "types/ts-scheduler/sources/views/Month.d.ts",
        "types/ts-scheduler/sources/views/Week.d.ts",
        "types/ts-scheduler/tests/suite.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/entry.d.ts",
        "types/ts-sidebar/sources/entry_pro.d.ts",
        "types/ts-sidebar/sources/ProSidebar.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-sidebar/tests/suite.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/entry.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-slider/tests/suite.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/entry.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-tabbar/tests/suite.d.ts",
        "types/ts-theme/entry.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/entry.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-timepicker/tests/suite.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/entry.d.ts",
        "types/ts-toolbar/sources/entry_pro.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-toolbar/tests/suite.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/entry.d.ts",
        "types/ts-tree/sources/entry_pro.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-tree/tests/suite.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/entry.d.ts",
        "types/ts-treegrid/sources/entry_pro.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-treegrid/tests/Grid.d.ts",
        "types/ts-treegrid/tests/stubs.d.ts",
        "types/ts-treegrid/tests/suite.d.ts",
        "types/ts-treegrid/tests/TreeGrid.d.ts",
        "types/ts-ui-kit/index.d.ts",
        "types/ts-ui-kit/sources/entry.d.ts",
        "types/ts-ui-kit/tests/suite.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/entry.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-vault/tests/suite.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/entry.d.ts",
        "types/ts-window/sources/entry_pro.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts",
        "types/ts-window/tests/suite.d.ts"
      ],
    },
    "suite@/8.3/suite": {
      libName: "suite_8.3",
      basePath: "suite/8.3",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-all/sources/entry_pro.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/entry.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-calendar/tests/calendar/calendar.d.ts",
        "types/ts-calendar/tests/suite.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/entry.d.ts",
        "types/ts-chart/sources/entry_pro.d.ts",
        "types/ts-chart/sources/Export.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/ProChart.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/CalendarHeatMap.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/series/TreeMap.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-chart/tests/Chart.d.ts",
        "types/ts-chart/tests/suite.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/entry.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-colorpicker/tests/suite.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/entry.d.ts",
        "types/ts-combobox/sources/entry_pro.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-combobox/tests/suite.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/tests/core.d.ts",
        "types/ts-common/tests/events.d.ts",
        "types/ts-common/tests/html.d.ts",
        "types/ts-common/tests/suite.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/entry.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-data/tests/ajax.d.ts",
        "types/ts-data/tests/drivers.d.ts",
        "types/ts-data/tests/filter.d.ts",
        "types/ts-data/tests/main.d.ts",
        "types/ts-data/tests/move.d.ts",
        "types/ts-data/tests/sort.d.ts",
        "types/ts-data/tests/suite.d.ts",
        "types/ts-data/tests/treecollection.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/entry.d.ts",
        "types/ts-dataview/sources/entry_pro.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-dataview/tests/selections/Selections.d.ts",
        "types/ts-dataview/tests/selections/stubs.d.ts",
        "types/ts-dataview/tests/suite.d.ts",
        "types/ts-diagram/index.d.ts",
        "types/ts-diagram/sources/Diagram.d.ts",
        "types/ts-diagram/sources/entry.d.ts",
        "types/ts-diagram/sources/helpers/Export.d.ts",
        "types/ts-diagram/sources/helpers/linkPaths.d.ts",
        "types/ts-diagram/sources/helpers/placement.d.ts",
        "types/ts-diagram/sources/helpers/Selection.d.ts",
        "types/ts-diagram/sources/locales/en.d.ts",
        "types/ts-diagram/sources/shapes/Base.d.ts",
        "types/ts-diagram/sources/shapes/Connector/Line.d.ts",
        "types/ts-diagram/sources/shapes/Diagram/DiagramCard.d.ts",
        "types/ts-diagram/sources/shapes/Diagram/DiagramImgCard.d.ts",
        "types/ts-diagram/sources/shapes/Diagram/DiagramSvgCard.d.ts",
        "types/ts-diagram/sources/shapes/Diagram/templates.d.ts",
        "types/ts-diagram/sources/shapes/factory.d.ts",
        "types/ts-diagram/sources/shapes/FlowShape.d.ts",
        "types/ts-diagram/sources/shapes/TextShape.d.ts",
        "types/ts-diagram/sources/ShapesCollection.d.ts",
        "types/ts-diagram/sources/Toolbar.d.ts",
        "types/ts-diagram/sources/types.d.ts",
        "types/ts-diagram/tests/stubs.d.ts",
        "types/ts-diagram/tests/suite.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/avatar.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/fieldset.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/proCombo.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/elements/ToggleButton.d.ts",
        "types/ts-form/sources/elements/ToggleGroup.d.ts",
        "types/ts-form/sources/entry.d.ts",
        "types/ts-form/sources/entry_pro.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-form/tests/elements/button.d.ts",
        "types/ts-form/tests/elements/checkbox.d.ts",
        "types/ts-form/tests/elements/colorpicker.d.ts",
        "types/ts-form/tests/elements/combo.d.ts",
        "types/ts-form/tests/elements/container.d.ts",
        "types/ts-form/tests/elements/datepicker.d.ts",
        "types/ts-form/tests/elements/input.d.ts",
        "types/ts-form/tests/elements/radiogroup.d.ts",
        "types/ts-form/tests/elements/select.d.ts",
        "types/ts-form/tests/elements/simplevault.d.ts",
        "types/ts-form/tests/elements/slider.d.ts",
        "types/ts-form/tests/elements/textarea.d.ts",
        "types/ts-form/tests/elements/timepicker.d.ts",
        "types/ts-form/tests/form.d.ts",
        "types/ts-form/tests/stubs/stubs.d.ts",
        "types/ts-form/tests/stubs/stubsCheckbox.d.ts",
        "types/ts-form/tests/stubs/stubsColorpicker.d.ts",
        "types/ts-form/tests/stubs/stubsCombo.d.ts",
        "types/ts-form/tests/stubs/stubsDatepicker.d.ts",
        "types/ts-form/tests/stubs/stubsInput.d.ts",
        "types/ts-form/tests/stubs/stubsRadiogroup.d.ts",
        "types/ts-form/tests/stubs/stubsSelect.d.ts",
        "types/ts-form/tests/stubs/stubsSlider.d.ts",
        "types/ts-form/tests/stubs/stubsTimepicker.d.ts",
        "types/ts-form/tests/suite.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/entry.d.ts",
        "types/ts-grid/sources/entry_pro.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-grid/tests/Grid.d.ts",
        "types/ts-grid/tests/stubs.d.ts",
        "types/ts-grid/tests/suite.d.ts",
        "types/ts-grid/tests/TreeGrid.d.ts",
        "types/ts-helpers/entry.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/entry.d.ts",
        "types/ts-layout/sources/entry_pro.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-layout/tests/Layout.d.ts",
        "types/ts-layout/tests/suite.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/entry.d.ts",
        "types/ts-list/sources/entry_pro.d.ts",
        "types/ts-list/sources/helpers.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-list/tests/selections/Selections.d.ts",
        "types/ts-list/tests/selections/stubs.d.ts",
        "types/ts-list/tests/suite.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/entry.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-menu/tests/suite.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/entry.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-message/tests/suite.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-navbar/tests/suite.d.ts",
        "types/ts-optimus/index.d.ts",
        "types/ts-optimus/sources/DHXApp.d.ts",
        "types/ts-optimus/sources/DHXView.d.ts",
        "types/ts-optimus/sources/EventSystem.d.ts",
        "types/ts-optimus/sources/HTMLCell.d.ts",
        "types/ts-optimus/sources/LocalSession.d.ts",
        "types/ts-optimus/sources/types.d.ts",
        "types/ts-pagination/index.d.ts",
        "types/ts-pagination/sources/entry.d.ts",
        "types/ts-pagination/sources/Pagination.d.ts",
        "types/ts-pagination/sources/types.d.ts",
        "types/ts-pagination/tests/suite.d.ts",
        "types/ts-pivot/index.d.ts",
        "types/ts-pivot/sources/configurator/Configurator.d.ts",
        "types/ts-pivot/sources/DataPreprocessor.d.ts",
        "types/ts-pivot/sources/DateFormatter.d.ts",
        "types/ts-pivot/sources/entry.d.ts",
        "types/ts-pivot/sources/filters/DateFilter.d.ts",
        "types/ts-pivot/sources/filters/Filter.d.ts",
        "types/ts-pivot/sources/filters/Filters.d.ts",
        "types/ts-pivot/sources/filters/helpers.d.ts",
        "types/ts-pivot/sources/group-module/DataGroup.d.ts",
        "types/ts-pivot/sources/group-module/groupfuncs.d.ts",
        "types/ts-pivot/sources/group-module/types.d.ts",
        "types/ts-pivot/sources/helpers.d.ts",
        "types/ts-pivot/sources/locales/en.d.ts",
        "types/ts-pivot/sources/Pivot.d.ts",
        "types/ts-pivot/sources/templates.d.ts",
        "types/ts-pivot/sources/types.d.ts",
        "types/ts-pivot/tests/config-module/Config.d.ts",
        "types/ts-pivot/tests/config-module/stubs.d.ts",
        "types/ts-pivot/tests/DataPreprocessor.d.ts",
        "types/ts-pivot/tests/filter-module/Filter.d.ts",
        "types/ts-pivot/tests/group-module/DataGroup.d.ts",
        "types/ts-pivot/tests/group-module/groupfuncs.d.ts",
        "types/ts-pivot/tests/group-module/stubs.d.ts",
        "types/ts-pivot/tests/Pivot.d.ts",
        "types/ts-pivot/tests/stubs.d.ts",
        "types/ts-pivot/tests/suite.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/entry.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-popup/tests/suite.d.ts",
        "types/ts-property/index.d.ts",
        "types/ts-property/sources/entry.d.ts",
        "types/ts-property/sources/items/BaseItem.d.ts",
        "types/ts-property/sources/items/Checkbox.d.ts",
        "types/ts-property/sources/items/Colorpicker.d.ts",
        "types/ts-property/sources/items/Combo.d.ts",
        "types/ts-property/sources/items/helpers.d.ts",
        "types/ts-property/sources/items/index.d.ts",
        "types/ts-property/sources/items/Label.d.ts",
        "types/ts-property/sources/items/Select.d.ts",
        "types/ts-property/sources/items/Text.d.ts",
        "types/ts-property/sources/items/Textarea.d.ts",
        "types/ts-property/sources/Property.d.ts",
        "types/ts-property/sources/types.d.ts",
        "types/ts-property/tests/suite.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/entry.d.ts",
        "types/ts-ribbon/sources/entry_pro.d.ts",
        "types/ts-ribbon/sources/ProRibbon.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-ribbon/tests/suite.d.ts",
        "types/ts-richtext/index.d.ts",
        "types/ts-richtext/sources/constants.d.ts",
        "types/ts-richtext/sources/entry.d.ts",
        "types/ts-richtext/sources/helpers/buffer.d.ts",
        "types/ts-richtext/sources/helpers/composition.d.ts",
        "types/ts-richtext/sources/helpers/link.d.ts",
        "types/ts-richtext/sources/helpers/markdown.d.ts",
        "types/ts-richtext/sources/helpers/minimizer.d.ts",
        "types/ts-richtext/sources/helpers/other.d.ts",
        "types/ts-richtext/sources/helpers/parser.d.ts",
        "types/ts-richtext/sources/helpers/scroll.d.ts",
        "types/ts-richtext/sources/helpers/selection.d.ts",
        "types/ts-richtext/sources/helpers/serializer.d.ts",
        "types/ts-richtext/sources/helpers/statistics.d.ts",
        "types/ts-richtext/sources/helpers/styles.d.ts",
        "types/ts-richtext/sources/helpers/toolbar.d.ts",
        "types/ts-richtext/sources/keyhandler.d.ts",
        "types/ts-richtext/sources/locales/en.d.ts",
        "types/ts-richtext/sources/Manager.d.ts",
        "types/ts-richtext/sources/models/Block.d.ts",
        "types/ts-richtext/sources/models/Editor.d.ts",
        "types/ts-richtext/sources/models/TextNode.d.ts",
        "types/ts-richtext/sources/Richtext.d.ts",
        "types/ts-richtext/sources/SelectionHelper.d.ts",
        "types/ts-richtext/sources/types.d.ts",
        "types/ts-richtext/tests/block.d.ts",
        "types/ts-richtext/tests/editor.d.ts",
        "types/ts-richtext/tests/suite.d.ts",
        "types/ts-richtext/tests/textnode.d.ts",
        "types/ts-samplegen/index.d.ts",
        "types/ts-samplegen/sources/entry.d.ts",
        "types/ts-samplegen/sources/SampleGenerator.d.ts",
        "types/ts-samplegen/tests/suite.d.ts",
        "types/ts-scheduler/index.d.ts",
        "types/ts-scheduler/sources/entry.d.ts",
        "types/ts-scheduler/sources/helpers/scales.d.ts",
        "types/ts-scheduler/sources/helpers/topbar.d.ts",
        "types/ts-scheduler/sources/Scheduler.d.ts",
        "types/ts-scheduler/sources/views/Agenda.d.ts",
        "types/ts-scheduler/sources/views/Base.d.ts",
        "types/ts-scheduler/sources/views/Cols.d.ts",
        "types/ts-scheduler/sources/views/Day.d.ts",
        "types/ts-scheduler/sources/views/index.d.ts",
        "types/ts-scheduler/sources/views/Month.d.ts",
        "types/ts-scheduler/sources/views/Week.d.ts",
        "types/ts-scheduler/tests/suite.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/entry.d.ts",
        "types/ts-sidebar/sources/entry_pro.d.ts",
        "types/ts-sidebar/sources/ProSidebar.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-sidebar/tests/suite.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/entry.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-slider/tests/suite.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/entry.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-tabbar/tests/suite.d.ts",
        "types/ts-theme/entry.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/entry.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-timepicker/tests/suite.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/entry.d.ts",
        "types/ts-toolbar/sources/entry_pro.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-toolbar/tests/suite.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/entry.d.ts",
        "types/ts-tree/sources/entry_pro.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-tree/tests/suite.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/entry.d.ts",
        "types/ts-treegrid/sources/entry_pro.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-treegrid/tests/Grid.d.ts",
        "types/ts-treegrid/tests/stubs.d.ts",
        "types/ts-treegrid/tests/suite.d.ts",
        "types/ts-treegrid/tests/TreeGrid.d.ts",
        "types/ts-ui-kit/index.d.ts",
        "types/ts-ui-kit/sources/entry.d.ts",
        "types/ts-ui-kit/tests/suite.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/entry.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-vault/tests/suite.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/entry.d.ts",
        "types/ts-window/sources/entry_pro.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts",
        "types/ts-window/tests/suite.d.ts"
      ],
    },
    "suite@pro/8.2/suite": {
      libName: "suite_8.2",
      basePath: "suite/pro/8.2",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-all/sources/entry_pro.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Export.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/ProChart.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/CalendarHeatMap.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/series/TreeMap.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/avatar.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/fieldset.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/elements/ToggleButton.d.ts",
        "types/ts-form/sources/elements/ToggleGroup.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-pagination/index.d.ts",
        "types/ts-pagination/sources/Pagination.d.ts",
        "types/ts-pagination/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/ProRibbon.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/ProSidebar.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts"
      ],
    },
    "suite@/8.2/suite": {
      libName: "suite_8.2",
      basePath: "suite/8.2",
      path: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-all/sources/entry_pro.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Export.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/ProChart.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/CalendarHeatMap.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/series/TreeMap.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/avatar.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/fieldset.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/elements/ToggleButton.d.ts",
        "types/ts-form/sources/elements/ToggleGroup.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-pagination/index.d.ts",
        "types/ts-pagination/sources/Pagination.d.ts",
        "types/ts-pagination/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/ProRibbon.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/ProSidebar.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts"
      ],
    },
    "suite@pro/8.1/suite": {
      libName: "suite_8.1",
      basePath: "suite/pro/8.1",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-all/sources/entry_pro.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Export.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/ProChart.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/CalendarHeatMap.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/series/TreeMap.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-pagination/index.d.ts",
        "types/ts-pagination/sources/Pagination.d.ts",
        "types/ts-pagination/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/ProRibbon.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/ProSidebar.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts"
      ],
    },
    "suite@/8.1/suite": {
      libName: "suite_8.1",
      basePath: "suite/8.1",
      path: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-all/sources/entry_pro.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Export.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/ProChart.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/CalendarHeatMap.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/series/TreeMap.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-pagination/index.d.ts",
        "types/ts-pagination/sources/Pagination.d.ts",
        "types/ts-pagination/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/ProRibbon.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/ProSidebar.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts"
      ],
    },
    "suite@pro/8.0/suite": {
      libName: "suite_8.0",
      basePath: "suite/pro/8.0",
      paths: [
        "/suite.d.ts",
        "/types/ts-all/sources/entry.d.ts",
        "/types/ts-all/sources/entry_pro.d.ts",
        "/types/ts-calendar/index.d.ts",
        "/types/ts-calendar/sources/Calendar.d.ts",
        "/types/ts-calendar/sources/helper.d.ts",
        "/types/ts-calendar/sources/types.d.ts",
        "/types/ts-chart/index.d.ts",
        "/types/ts-chart/sources/AxisCreator.d.ts",
        "/types/ts-chart/sources/Chart.d.ts",
        "/types/ts-chart/sources/ComposeLayer.d.ts",
        "/types/ts-chart/sources/Export.d.ts",
        "/types/ts-chart/sources/Filters.d.ts",
        "/types/ts-chart/sources/helpers/circle.d.ts",
        "/types/ts-chart/sources/helpers/common.d.ts",
        "/types/ts-chart/sources/helpers/spline.d.ts",
        "/types/ts-chart/sources/Legend.d.ts",
        "/types/ts-chart/sources/ProChart.d.ts",
        "/types/ts-chart/sources/scales/index.d.ts",
        "/types/ts-chart/sources/scales/RadialScale.d.ts",
        "/types/ts-chart/sources/scales/Scale.d.ts",
        "/types/ts-chart/sources/scales/SvgScales.d.ts",
        "/types/ts-chart/sources/scales/TextScale.d.ts",
        "/types/ts-chart/sources/series/Area.d.ts",
        "/types/ts-chart/sources/series/Bar.d.ts",
        "/types/ts-chart/sources/series/BarX.d.ts",
        "/types/ts-chart/sources/series/BaseSeria.d.ts",
        "/types/ts-chart/sources/series/CalendarHeatMap.d.ts",
        "/types/ts-chart/sources/series/Donut.d.ts",
        "/types/ts-chart/sources/series/index.d.ts",
        "/types/ts-chart/sources/series/Line.d.ts",
        "/types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "/types/ts-chart/sources/series/Pie.d.ts",
        "/types/ts-chart/sources/series/Pie3D.d.ts",
        "/types/ts-chart/sources/series/Radar.d.ts",
        "/types/ts-chart/sources/series/ScaleSeria.d.ts",
        "/types/ts-chart/sources/series/Scatter.d.ts",
        "/types/ts-chart/sources/series/Spline.d.ts",
        "/types/ts-chart/sources/series/SplineArea.d.ts",
        "/types/ts-chart/sources/series/Stacker.d.ts",
        "/types/ts-chart/sources/series/TreeMap.d.ts",
        "/types/ts-chart/sources/shapes/legend.d.ts",
        "/types/ts-chart/sources/shapes/line.d.ts",
        "/types/ts-chart/sources/Tooltip.d.ts",
        "/types/ts-chart/sources/types.d.ts",
        "/types/ts-colorpicker/index.d.ts",
        "/types/ts-colorpicker/sources/Colorpicker.d.ts",
        "/types/ts-colorpicker/sources/colors.d.ts",
        "/types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "/types/ts-colorpicker/sources/helpers/color.d.ts",
        "/types/ts-colorpicker/sources/locales/en.d.ts",
        "/types/ts-colorpicker/sources/picker.d.ts",
        "/types/ts-colorpicker/sources/types.d.ts",
        "/types/ts-combobox/index.d.ts",
        "/types/ts-combobox/sources/Combobox.d.ts",
        "/types/ts-combobox/sources/helper.d.ts",
        "/types/ts-combobox/sources/keyListener.d.ts",
        "/types/ts-combobox/sources/locales/en.d.ts",
        "/types/ts-combobox/sources/ProCombobox.d.ts",
        "/types/ts-combobox/sources/types.d.ts",
        "/types/ts-common/core.d.ts",
        "/types/ts-common/CssManager.d.ts",
        "/types/ts-common/date.d.ts",
        "/types/ts-common/dom.d.ts",
        "/types/ts-common/events.d.ts",
        "/types/ts-common/FocusManager.d.ts",
        "/types/ts-common/html.d.ts",
        "/types/ts-common/keycodes.d.ts",
        "/types/ts-common/KeyManager.d.ts",
        "/types/ts-common/polyfills/array.d.ts",
        "/types/ts-common/polyfills/element.d.ts",
        "/types/ts-common/polyfills/math.d.ts",
        "/types/ts-common/polyfills/object.d.ts",
        "/types/ts-common/polyfills/string.d.ts",
        "/types/ts-common/ScrollView.d.ts",
        "/types/ts-common/types.d.ts",
        "/types/ts-common/view.d.ts",
        "/types/ts-data/index.d.ts",
        "/types/ts-data/sources/ajax.d.ts",
        "/types/ts-data/sources/CollectionStore.d.ts",
        "/types/ts-data/sources/datacollection/loader.d.ts",
        "/types/ts-data/sources/datacollection/sort.d.ts",
        "/types/ts-data/sources/datacollection.d.ts",
        "/types/ts-data/sources/dataproxy.d.ts",
        "/types/ts-data/sources/DragManager.d.ts",
        "/types/ts-data/sources/drivers/CsvDriver.d.ts",
        "/types/ts-data/sources/drivers/drivers.d.ts",
        "/types/ts-data/sources/drivers/JsonDriver.d.ts",
        "/types/ts-data/sources/drivers/XMLDriver.d.ts",
        "/types/ts-data/sources/helpers.d.ts",
        "/types/ts-data/sources/lazydataproxy.d.ts",
        "/types/ts-data/sources/selection.d.ts",
        "/types/ts-data/sources/serializers/xml.d.ts",
        "/types/ts-data/sources/treecollection.d.ts",
        "/types/ts-data/sources/types.d.ts",
        "/types/ts-dataview/index.d.ts",
        "/types/ts-dataview/sources/DataView.d.ts",
        "/types/ts-dataview/sources/editors/editors.d.ts",
        "/types/ts-dataview/sources/editors/InputEditor.d.ts",
        "/types/ts-dataview/sources/ProDataView.d.ts",
        "/types/ts-dataview/sources/types.d.ts",
        "/types/ts-form/index.d.ts",
        "/types/ts-form/sources/elements/button.d.ts",
        "/types/ts-form/sources/elements/checkbox.d.ts",
        "/types/ts-form/sources/elements/checkboxGroup.d.ts",
        "/types/ts-form/sources/elements/colorpicker.d.ts",
        "/types/ts-form/sources/elements/combo.d.ts",
        "/types/ts-form/sources/elements/container.d.ts",
        "/types/ts-form/sources/elements/dateinput.d.ts",
        "/types/ts-form/sources/elements/helper/label.d.ts",
        "/types/ts-form/sources/elements/input.d.ts",
        "/types/ts-form/sources/elements/radiobutton.d.ts",
        "/types/ts-form/sources/elements/radioGroup.d.ts",
        "/types/ts-form/sources/elements/select.d.ts",
        "/types/ts-form/sources/elements/simplevault.d.ts",
        "/types/ts-form/sources/elements/sliderform.d.ts",
        "/types/ts-form/sources/elements/spacer.d.ts",
        "/types/ts-form/sources/elements/textarea.d.ts",
        "/types/ts-form/sources/elements/textinput.d.ts",
        "/types/ts-form/sources/elements/timeinput.d.ts",
        "/types/ts-form/sources/Form.d.ts",
        "/types/ts-form/sources/helper.d.ts",
        "/types/ts-form/sources/locales/en.d.ts",
        "/types/ts-form/sources/ProForm.d.ts",
        "/types/ts-form/sources/types.d.ts",
        "/types/ts-grid/index.d.ts",
        "/types/ts-grid/sources/columnsResizer.d.ts",
        "/types/ts-grid/sources/Exporter.d.ts",
        "/types/ts-grid/sources/Grid.d.ts",
        "/types/ts-grid/sources/helpers/cells.d.ts",
        "/types/ts-grid/sources/helpers/data.d.ts",
        "/types/ts-grid/sources/helpers/keys.d.ts",
        "/types/ts-grid/sources/helpers/main.d.ts",
        "/types/ts-grid/sources/ProGrid.d.ts",
        "/types/ts-grid/sources/Selection.d.ts",
        "/types/ts-grid/sources/types.d.ts",
        "/types/ts-grid/sources/ui/Cells.d.ts",
        "/types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "/types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "/types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "/types/ts-grid/sources/ui/content.d.ts",
        "/types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "/types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "/types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "/types/ts-grid/sources/ui/editors/editors.d.ts",
        "/types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "/types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "/types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "/types/ts-grid/sources/ui/FixedCols.d.ts",
        "/types/ts-grid/sources/ui/FixedRows.d.ts",
        "/types/ts-grid/sources/ui/render.d.ts",
        "/types/ts-layout/index.d.ts",
        "/types/ts-layout/sources/Cell.d.ts",
        "/types/ts-layout/sources/helpers.d.ts",
        "/types/ts-layout/sources/Layout.d.ts",
        "/types/ts-layout/sources/ProCell.d.ts",
        "/types/ts-layout/sources/ProLayout.d.ts",
        "/types/ts-layout/sources/types.d.ts",
        "/types/ts-list/index.d.ts",
        "/types/ts-list/sources/editors/editors.d.ts",
        "/types/ts-list/sources/editors/InputEditor.d.ts",
        "/types/ts-list/sources/List.d.ts",
        "/types/ts-list/sources/ProList.d.ts",
        "/types/ts-list/sources/Selection.d.ts",
        "/types/ts-list/sources/types.d.ts",
        "/types/ts-menu/index.d.ts",
        "/types/ts-menu/sources/ContextMenu.d.ts",
        "/types/ts-menu/sources/Menu.d.ts",
        "/types/ts-message/index.d.ts",
        "/types/ts-message/sources/alert.d.ts",
        "/types/ts-message/sources/common.d.ts",
        "/types/ts-message/sources/confirm.d.ts",
        "/types/ts-message/sources/locales/en.d.ts",
        "/types/ts-message/sources/message.d.ts",
        "/types/ts-message/sources/tooltip.d.ts",
        "/types/ts-message/sources/types.d.ts",
        "/types/ts-navbar/index.d.ts",
        "/types/ts-navbar/sources/elements/button.d.ts",
        "/types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "/types/ts-navbar/sources/elements/datePicker.d.ts",
        "/types/ts-navbar/sources/elements/helpers.d.ts",
        "/types/ts-navbar/sources/elements/imageButton.d.ts",
        "/types/ts-navbar/sources/elements/input.d.ts",
        "/types/ts-navbar/sources/elements/menuItem.d.ts",
        "/types/ts-navbar/sources/elements/navItem.d.ts",
        "/types/ts-navbar/sources/elements/separator.d.ts",
        "/types/ts-navbar/sources/elements/spacer.d.ts",
        "/types/ts-navbar/sources/elements/title.d.ts",
        "/types/ts-navbar/sources/itemfactory.d.ts",
        "/types/ts-navbar/sources/Navbar.d.ts",
        "/types/ts-navbar/sources/types.d.ts",
        "/types/ts-pagination/index.d.ts",
        "/types/ts-pagination/sources/Pagination.d.ts",
        "/types/ts-pagination/sources/types.d.ts",
        "/types/ts-popup/index.d.ts",
        "/types/ts-popup/sources/Popup.d.ts",
        "/types/ts-popup/sources/types.d.ts",
        "/types/ts-ribbon/index.d.ts",
        "/types/ts-ribbon/sources/ProRibbon.d.ts",
        "/types/ts-ribbon/sources/Ribbon.d.ts",
        "/types/ts-sidebar/index.d.ts",
        "/types/ts-sidebar/sources/ProSidebar.d.ts",
        "/types/ts-sidebar/sources/Sidebar.d.ts",
        "/types/ts-sidebar/sources/types.d.ts",
        "/types/ts-slider/index.d.ts",
        "/types/ts-slider/sources/Slider.d.ts",
        "/types/ts-slider/sources/types.d.ts",
        "/types/ts-tabbar/index.d.ts",
        "/types/ts-tabbar/sources/Tabbar.d.ts",
        "/types/ts-tabbar/sources/types.d.ts",
        "/types/ts-timepicker/index.d.ts",
        "/types/ts-timepicker/sources/helper.d.ts",
        "/types/ts-timepicker/sources/locales/en.d.ts",
        "/types/ts-timepicker/sources/Timepicker.d.ts",
        "/types/ts-timepicker/sources/types.d.ts",
        "/types/ts-toolbar/index.d.ts",
        "/types/ts-toolbar/sources/ProToolbar.d.ts",
        "/types/ts-toolbar/sources/Toolbar.d.ts",
        "/types/ts-tree/index.d.ts",
        "/types/ts-tree/sources/Editor.d.ts",
        "/types/ts-tree/sources/Tree.d.ts",
        "/types/ts-tree/sources/types.d.ts",
        "/types/ts-treegrid/index.d.ts",
        "/types/ts-treegrid/sources/TreeGrid.d.ts",
        "/types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "/types/ts-treegrid/sources/types.d.ts",
        "/types/ts-vault/index.d.ts",
        "/types/ts-vault/sources/configs.d.ts",
        "/types/ts-vault/sources/helper.d.ts",
        "/types/ts-vault/sources/locales/en.d.ts",
        "/types/ts-vault/sources/ProgressBar.d.ts",
        "/types/ts-vault/sources/ReadStackPreview.d.ts",
        "/types/ts-vault/sources/types.d.ts",
        "/types/ts-vault/sources/Uploader.d.ts",
        "/types/ts-vault/sources/Vault.d.ts",
        "/types/ts-window/index.d.ts",
        "/types/ts-window/sources/helpers.d.ts",
        "/types/ts-window/sources/ProWindow.d.ts",
        "/types/ts-window/sources/types.d.ts",
        "/types/ts-window/sources/Window.d.ts",
        "/types/ts-window/sources/WindowController.d.ts"
      ],
    },
    "suite@/8.0/suite": {
      libName: "suite_8.0",
      basePath: "suite/8.0",
      path: [
        "/suite.d.ts",
        "/types/ts-all/sources/entry.d.ts",
        "/types/ts-all/sources/entry_pro.d.ts",
        "/types/ts-calendar/index.d.ts",
        "/types/ts-calendar/sources/Calendar.d.ts",
        "/types/ts-calendar/sources/helper.d.ts",
        "/types/ts-calendar/sources/types.d.ts",
        "/types/ts-chart/index.d.ts",
        "/types/ts-chart/sources/AxisCreator.d.ts",
        "/types/ts-chart/sources/Chart.d.ts",
        "/types/ts-chart/sources/ComposeLayer.d.ts",
        "/types/ts-chart/sources/Export.d.ts",
        "/types/ts-chart/sources/Filters.d.ts",
        "/types/ts-chart/sources/helpers/circle.d.ts",
        "/types/ts-chart/sources/helpers/common.d.ts",
        "/types/ts-chart/sources/helpers/spline.d.ts",
        "/types/ts-chart/sources/Legend.d.ts",
        "/types/ts-chart/sources/ProChart.d.ts",
        "/types/ts-chart/sources/scales/index.d.ts",
        "/types/ts-chart/sources/scales/RadialScale.d.ts",
        "/types/ts-chart/sources/scales/Scale.d.ts",
        "/types/ts-chart/sources/scales/SvgScales.d.ts",
        "/types/ts-chart/sources/scales/TextScale.d.ts",
        "/types/ts-chart/sources/series/Area.d.ts",
        "/types/ts-chart/sources/series/Bar.d.ts",
        "/types/ts-chart/sources/series/BarX.d.ts",
        "/types/ts-chart/sources/series/BaseSeria.d.ts",
        "/types/ts-chart/sources/series/CalendarHeatMap.d.ts",
        "/types/ts-chart/sources/series/Donut.d.ts",
        "/types/ts-chart/sources/series/index.d.ts",
        "/types/ts-chart/sources/series/Line.d.ts",
        "/types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "/types/ts-chart/sources/series/Pie.d.ts",
        "/types/ts-chart/sources/series/Pie3D.d.ts",
        "/types/ts-chart/sources/series/Radar.d.ts",
        "/types/ts-chart/sources/series/ScaleSeria.d.ts",
        "/types/ts-chart/sources/series/Scatter.d.ts",
        "/types/ts-chart/sources/series/Spline.d.ts",
        "/types/ts-chart/sources/series/SplineArea.d.ts",
        "/types/ts-chart/sources/series/Stacker.d.ts",
        "/types/ts-chart/sources/series/TreeMap.d.ts",
        "/types/ts-chart/sources/shapes/legend.d.ts",
        "/types/ts-chart/sources/shapes/line.d.ts",
        "/types/ts-chart/sources/Tooltip.d.ts",
        "/types/ts-chart/sources/types.d.ts",
        "/types/ts-colorpicker/index.d.ts",
        "/types/ts-colorpicker/sources/Colorpicker.d.ts",
        "/types/ts-colorpicker/sources/colors.d.ts",
        "/types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "/types/ts-colorpicker/sources/helpers/color.d.ts",
        "/types/ts-colorpicker/sources/locales/en.d.ts",
        "/types/ts-colorpicker/sources/picker.d.ts",
        "/types/ts-colorpicker/sources/types.d.ts",
        "/types/ts-combobox/index.d.ts",
        "/types/ts-combobox/sources/Combobox.d.ts",
        "/types/ts-combobox/sources/helper.d.ts",
        "/types/ts-combobox/sources/keyListener.d.ts",
        "/types/ts-combobox/sources/locales/en.d.ts",
        "/types/ts-combobox/sources/ProCombobox.d.ts",
        "/types/ts-combobox/sources/types.d.ts",
        "/types/ts-common/core.d.ts",
        "/types/ts-common/CssManager.d.ts",
        "/types/ts-common/date.d.ts",
        "/types/ts-common/dom.d.ts",
        "/types/ts-common/events.d.ts",
        "/types/ts-common/FocusManager.d.ts",
        "/types/ts-common/html.d.ts",
        "/types/ts-common/keycodes.d.ts",
        "/types/ts-common/KeyManager.d.ts",
        "/types/ts-common/polyfills/array.d.ts",
        "/types/ts-common/polyfills/element.d.ts",
        "/types/ts-common/polyfills/math.d.ts",
        "/types/ts-common/polyfills/object.d.ts",
        "/types/ts-common/polyfills/string.d.ts",
        "/types/ts-common/ScrollView.d.ts",
        "/types/ts-common/types.d.ts",
        "/types/ts-common/view.d.ts",
        "/types/ts-data/index.d.ts",
        "/types/ts-data/sources/ajax.d.ts",
        "/types/ts-data/sources/CollectionStore.d.ts",
        "/types/ts-data/sources/datacollection/loader.d.ts",
        "/types/ts-data/sources/datacollection/sort.d.ts",
        "/types/ts-data/sources/datacollection.d.ts",
        "/types/ts-data/sources/dataproxy.d.ts",
        "/types/ts-data/sources/DragManager.d.ts",
        "/types/ts-data/sources/drivers/CsvDriver.d.ts",
        "/types/ts-data/sources/drivers/drivers.d.ts",
        "/types/ts-data/sources/drivers/JsonDriver.d.ts",
        "/types/ts-data/sources/drivers/XMLDriver.d.ts",
        "/types/ts-data/sources/helpers.d.ts",
        "/types/ts-data/sources/lazydataproxy.d.ts",
        "/types/ts-data/sources/selection.d.ts",
        "/types/ts-data/sources/serializers/xml.d.ts",
        "/types/ts-data/sources/treecollection.d.ts",
        "/types/ts-data/sources/types.d.ts",
        "/types/ts-dataview/index.d.ts",
        "/types/ts-dataview/sources/DataView.d.ts",
        "/types/ts-dataview/sources/editors/editors.d.ts",
        "/types/ts-dataview/sources/editors/InputEditor.d.ts",
        "/types/ts-dataview/sources/ProDataView.d.ts",
        "/types/ts-dataview/sources/types.d.ts",
        "/types/ts-form/index.d.ts",
        "/types/ts-form/sources/elements/button.d.ts",
        "/types/ts-form/sources/elements/checkbox.d.ts",
        "/types/ts-form/sources/elements/checkboxGroup.d.ts",
        "/types/ts-form/sources/elements/colorpicker.d.ts",
        "/types/ts-form/sources/elements/combo.d.ts",
        "/types/ts-form/sources/elements/container.d.ts",
        "/types/ts-form/sources/elements/dateinput.d.ts",
        "/types/ts-form/sources/elements/helper/label.d.ts",
        "/types/ts-form/sources/elements/input.d.ts",
        "/types/ts-form/sources/elements/radiobutton.d.ts",
        "/types/ts-form/sources/elements/radioGroup.d.ts",
        "/types/ts-form/sources/elements/select.d.ts",
        "/types/ts-form/sources/elements/simplevault.d.ts",
        "/types/ts-form/sources/elements/sliderform.d.ts",
        "/types/ts-form/sources/elements/spacer.d.ts",
        "/types/ts-form/sources/elements/textarea.d.ts",
        "/types/ts-form/sources/elements/textinput.d.ts",
        "/types/ts-form/sources/elements/timeinput.d.ts",
        "/types/ts-form/sources/Form.d.ts",
        "/types/ts-form/sources/helper.d.ts",
        "/types/ts-form/sources/locales/en.d.ts",
        "/types/ts-form/sources/ProForm.d.ts",
        "/types/ts-form/sources/types.d.ts",
        "/types/ts-grid/index.d.ts",
        "/types/ts-grid/sources/columnsResizer.d.ts",
        "/types/ts-grid/sources/Exporter.d.ts",
        "/types/ts-grid/sources/Grid.d.ts",
        "/types/ts-grid/sources/helpers/cells.d.ts",
        "/types/ts-grid/sources/helpers/data.d.ts",
        "/types/ts-grid/sources/helpers/keys.d.ts",
        "/types/ts-grid/sources/helpers/main.d.ts",
        "/types/ts-grid/sources/ProGrid.d.ts",
        "/types/ts-grid/sources/Selection.d.ts",
        "/types/ts-grid/sources/types.d.ts",
        "/types/ts-grid/sources/ui/Cells.d.ts",
        "/types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "/types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "/types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "/types/ts-grid/sources/ui/content.d.ts",
        "/types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "/types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "/types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "/types/ts-grid/sources/ui/editors/editors.d.ts",
        "/types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "/types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "/types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "/types/ts-grid/sources/ui/FixedCols.d.ts",
        "/types/ts-grid/sources/ui/FixedRows.d.ts",
        "/types/ts-grid/sources/ui/render.d.ts",
        "/types/ts-layout/index.d.ts",
        "/types/ts-layout/sources/Cell.d.ts",
        "/types/ts-layout/sources/helpers.d.ts",
        "/types/ts-layout/sources/Layout.d.ts",
        "/types/ts-layout/sources/ProCell.d.ts",
        "/types/ts-layout/sources/ProLayout.d.ts",
        "/types/ts-layout/sources/types.d.ts",
        "/types/ts-list/index.d.ts",
        "/types/ts-list/sources/editors/editors.d.ts",
        "/types/ts-list/sources/editors/InputEditor.d.ts",
        "/types/ts-list/sources/List.d.ts",
        "/types/ts-list/sources/ProList.d.ts",
        "/types/ts-list/sources/Selection.d.ts",
        "/types/ts-list/sources/types.d.ts",
        "/types/ts-menu/index.d.ts",
        "/types/ts-menu/sources/ContextMenu.d.ts",
        "/types/ts-menu/sources/Menu.d.ts",
        "/types/ts-message/index.d.ts",
        "/types/ts-message/sources/alert.d.ts",
        "/types/ts-message/sources/common.d.ts",
        "/types/ts-message/sources/confirm.d.ts",
        "/types/ts-message/sources/locales/en.d.ts",
        "/types/ts-message/sources/message.d.ts",
        "/types/ts-message/sources/tooltip.d.ts",
        "/types/ts-message/sources/types.d.ts",
        "/types/ts-navbar/index.d.ts",
        "/types/ts-navbar/sources/elements/button.d.ts",
        "/types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "/types/ts-navbar/sources/elements/datePicker.d.ts",
        "/types/ts-navbar/sources/elements/helpers.d.ts",
        "/types/ts-navbar/sources/elements/imageButton.d.ts",
        "/types/ts-navbar/sources/elements/input.d.ts",
        "/types/ts-navbar/sources/elements/menuItem.d.ts",
        "/types/ts-navbar/sources/elements/navItem.d.ts",
        "/types/ts-navbar/sources/elements/separator.d.ts",
        "/types/ts-navbar/sources/elements/spacer.d.ts",
        "/types/ts-navbar/sources/elements/title.d.ts",
        "/types/ts-navbar/sources/itemfactory.d.ts",
        "/types/ts-navbar/sources/Navbar.d.ts",
        "/types/ts-navbar/sources/types.d.ts",
        "/types/ts-pagination/index.d.ts",
        "/types/ts-pagination/sources/Pagination.d.ts",
        "/types/ts-pagination/sources/types.d.ts",
        "/types/ts-popup/index.d.ts",
        "/types/ts-popup/sources/Popup.d.ts",
        "/types/ts-popup/sources/types.d.ts",
        "/types/ts-ribbon/index.d.ts",
        "/types/ts-ribbon/sources/ProRibbon.d.ts",
        "/types/ts-ribbon/sources/Ribbon.d.ts",
        "/types/ts-sidebar/index.d.ts",
        "/types/ts-sidebar/sources/ProSidebar.d.ts",
        "/types/ts-sidebar/sources/Sidebar.d.ts",
        "/types/ts-sidebar/sources/types.d.ts",
        "/types/ts-slider/index.d.ts",
        "/types/ts-slider/sources/Slider.d.ts",
        "/types/ts-slider/sources/types.d.ts",
        "/types/ts-tabbar/index.d.ts",
        "/types/ts-tabbar/sources/Tabbar.d.ts",
        "/types/ts-tabbar/sources/types.d.ts",
        "/types/ts-timepicker/index.d.ts",
        "/types/ts-timepicker/sources/helper.d.ts",
        "/types/ts-timepicker/sources/locales/en.d.ts",
        "/types/ts-timepicker/sources/Timepicker.d.ts",
        "/types/ts-timepicker/sources/types.d.ts",
        "/types/ts-toolbar/index.d.ts",
        "/types/ts-toolbar/sources/ProToolbar.d.ts",
        "/types/ts-toolbar/sources/Toolbar.d.ts",
        "/types/ts-tree/index.d.ts",
        "/types/ts-tree/sources/Editor.d.ts",
        "/types/ts-tree/sources/Tree.d.ts",
        "/types/ts-tree/sources/types.d.ts",
        "/types/ts-treegrid/index.d.ts",
        "/types/ts-treegrid/sources/TreeGrid.d.ts",
        "/types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "/types/ts-treegrid/sources/types.d.ts",
        "/types/ts-vault/index.d.ts",
        "/types/ts-vault/sources/configs.d.ts",
        "/types/ts-vault/sources/helper.d.ts",
        "/types/ts-vault/sources/locales/en.d.ts",
        "/types/ts-vault/sources/ProgressBar.d.ts",
        "/types/ts-vault/sources/ReadStackPreview.d.ts",
        "/types/ts-vault/sources/types.d.ts",
        "/types/ts-vault/sources/Uploader.d.ts",
        "/types/ts-vault/sources/Vault.d.ts",
        "/types/ts-window/index.d.ts",
        "/types/ts-window/sources/helpers.d.ts",
        "/types/ts-window/sources/ProWindow.d.ts",
        "/types/ts-window/sources/types.d.ts",
        "/types/ts-window/sources/Window.d.ts",
        "/types/ts-window/sources/WindowController.d.ts"
      ],
    },
    "suite@pro/7.3/suite": {
      libName: "suite_7.3",
      basePath: "suite/pro/7.3",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-all/sources/entry_pro.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/series/TreeMap.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/proCombo.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-pagination/index.d.ts",
        "types/ts-pagination/sources/Pagination.d.ts",
        "types/ts-pagination/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/ProRibbon.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/ProSidebar.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/types.d.ts",
      ],
    },
    "suite@/7.3/suite": {
      libName: "suite_7.3",
      basePath: "suite/7.3",
      path: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/series/TreeMap.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/proCombo.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/ProRibbon.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/ProSidebar.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/types.d.ts",
      ],
    },
    "suite@pro/7.2/suite": {
      libName: "suite_7.2",
      basePath: "suite/pro/7.2",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-all/sources/entry_pro.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/proCombo.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-pagination/index.d.ts",
        "types/ts-pagination/sources/Pagination.d.ts",
        "types/ts-pagination/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/ProRibbon.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/ProSidebar.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts",
      ],
    },
    "suite@/7.2/suite": {
      libName: "suite_7.2",
      basePath: "suite/7.2",
      path: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/proCombo.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/ProRibbon.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/ProSidebar.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts",
      ],
    },
    "suite@pro/7.1/suite": {
      libName: "suite_7.1",
      basePath: "suite/pro/7.1",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-all/sources/entry_pro.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/scrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-pagination/index.d.ts",
        "types/ts-pagination/sources/Pagination.d.ts",
        "types/ts-pagination/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts",
      ],
    },
    "suite@/7.1/suite": {
      libName: "suite_7.1",
      basePath: "suite/7.1",
      path: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/scrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts",
      ],
    },
    "suite@pro/7.0/suite": {
      libName: "suite_7.0",
      basePath: "suite/pro/7.0",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-all/sources/entry_pro.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/DateFormatter.d.ts",
        "types/ts-calendar/sources/DateHelper.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/locales/en.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/focus.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/Keymanager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/scrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/KeyManager.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-pagination/index.d.ts",
        "types/ts-pagination/sources/Pagination.d.ts",
        "types/ts-pagination/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/KeyManager.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts",
      ],
    },
    "suite@/7.0/suite": {
      libName: "suite_7.0",
      basePath: "suite/7.0",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/DateFormatter.d.ts",
        "types/ts-calendar/sources/DateHelper.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/locales/en.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/focus.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/Keymanager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/scrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/KeyManager.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/KeyManager.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts",
      ],
    },
    "suite@pro/6.5/suite": {
      libName: "suite_6.5",
      basePath: "suite/pro/6.5",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/DateFormatter.d.ts",
        "types/ts-calendar/sources/DateHelper.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/locales/en.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/Keymanager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/scrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/dateInput.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeInput.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/Hotkey.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/helpers.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-menu/sources/types.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-ribbon/sources/types.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-toolbar/sources/types.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/KeyNavigation.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts",
      ],
    },
    "suite@/6.5/suite": {
      libName: "suite_6.5",
      basePath: "suite/6.5",
      paths: [
        "suite.d.ts",
        "types/ts-all/sources/entry.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/DateFormatter.d.ts",
        "types/ts-calendar/sources/DateHelper.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/locales/en.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-chart/index.d.ts",
        "types/ts-chart/sources/AxisCreator.d.ts",
        "types/ts-chart/sources/Chart.d.ts",
        "types/ts-chart/sources/ComposeLayer.d.ts",
        "types/ts-chart/sources/Filters.d.ts",
        "types/ts-chart/sources/helpers/circle.d.ts",
        "types/ts-chart/sources/helpers/common.d.ts",
        "types/ts-chart/sources/helpers/spline.d.ts",
        "types/ts-chart/sources/Legend.d.ts",
        "types/ts-chart/sources/scales/index.d.ts",
        "types/ts-chart/sources/scales/RadialScale.d.ts",
        "types/ts-chart/sources/scales/Scale.d.ts",
        "types/ts-chart/sources/scales/SvgScales.d.ts",
        "types/ts-chart/sources/scales/TextScale.d.ts",
        "types/ts-chart/sources/series/Area.d.ts",
        "types/ts-chart/sources/series/Bar.d.ts",
        "types/ts-chart/sources/series/BarX.d.ts",
        "types/ts-chart/sources/series/BaseSeria.d.ts",
        "types/ts-chart/sources/series/Donut.d.ts",
        "types/ts-chart/sources/series/index.d.ts",
        "types/ts-chart/sources/series/Line.d.ts",
        "types/ts-chart/sources/series/NoScaleSeria.d.ts",
        "types/ts-chart/sources/series/Pie.d.ts",
        "types/ts-chart/sources/series/Pie3D.d.ts",
        "types/ts-chart/sources/series/Radar.d.ts",
        "types/ts-chart/sources/series/ScaleSeria.d.ts",
        "types/ts-chart/sources/series/Scatter.d.ts",
        "types/ts-chart/sources/series/Spline.d.ts",
        "types/ts-chart/sources/series/SplineArea.d.ts",
        "types/ts-chart/sources/series/Stacker.d.ts",
        "types/ts-chart/sources/shapes/legend.d.ts",
        "types/ts-chart/sources/shapes/line.d.ts",
        "types/ts-chart/sources/Tooltip.d.ts",
        "types/ts-chart/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/Keymanager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/scrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/dateInput.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeInput.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/Hotkey.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/helpers.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-menu/sources/types.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-ribbon/index.d.ts",
        "types/ts-ribbon/sources/Ribbon.d.ts",
        "types/ts-ribbon/sources/types.d.ts",
        "types/ts-sidebar/index.d.ts",
        "types/ts-sidebar/sources/Sidebar.d.ts",
        "types/ts-sidebar/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-tabbar/index.d.ts",
        "types/ts-tabbar/sources/Tabbar.d.ts",
        "types/ts-tabbar/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-toolbar/sources/types.d.ts",
        "types/ts-tree/index.d.ts",
        "types/ts-tree/sources/Editor.d.ts",
        "types/ts-tree/sources/KeyNavigation.d.ts",
        "types/ts-tree/sources/Tree.d.ts",
        "types/ts-tree/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts",
      ],
    },
  },
  pivot: {
    "pivot@pro/edge/pivot": {
      libName: "pivot_2.1",
      basePath: "pivot/pro/2.1",
      paths: ["pivot.d.ts"],
    },
    "pivot@pro/2.0/pivot": {
      libName: "pivot_2.0",
      basePath: "pivot/pro/2.0",
      paths: ["pivot.d.ts"],
    },
    "pivot@pro/1.5/pivot": {
      libName: "pivot_1.5",
      basePath: "pivot/pro/1.5",
      paths: [
        "pivot.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/DateFormatter.d.ts",
        "types/ts-calendar/sources/DateHelper.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/locales/en.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/Keymanager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/Hotkey.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/helpers.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-pivot/sources/configurator/Configurator.d.ts",
        "types/ts-pivot/sources/configurator/Fields.d.ts",
        "types/ts-pivot/sources/DataPreprocessor.d.ts",
        "types/ts-pivot/sources/DateFormatter.d.ts",
        "types/ts-pivot/sources/entry.d.ts",
        "types/ts-pivot/sources/Exporter.d.ts",
        "types/ts-pivot/sources/filters/DateFilter.d.ts",
        "types/ts-pivot/sources/filters/Filter.d.ts",
        "types/ts-pivot/sources/filters/Filters.d.ts",
        "types/ts-pivot/sources/group-module/DataGroup.d.ts",
        "types/ts-pivot/sources/group-module/groupfuncs.d.ts",
        "types/ts-pivot/sources/helpers.d.ts",
        "types/ts-pivot/sources/locales/en.d.ts",
        "types/ts-pivot/sources/Pivot.d.ts",
        "types/ts-pivot/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
      ],
    },
  },
  vault: {
    "vault@pro/edge/vault": {
      libName: "vault_5.0",
      basePath: "vault/pro/5.0",
      paths: [
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/locale.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/entry.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "vault.d.ts",
      ],
    },
    "vault@pro/5.0/vault": {
      libName: "vault_5.0",
      basePath: "vault/pro/5.0",
      paths: [
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/locale.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/entry.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "vault.d.ts",
      ],
    },
    "vault@pro/4.1/vault": {
      libName: "vault_4.1",
      basePath: "vault/pro/4.1",
      paths: [
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/entry.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "vault.d.ts",
      ],
    },
    "vault@pro/4.0/vault": {
      libName: "vault_4.0",
      basePath: "vault/pro/4.0",
      paths: [
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/Keymanager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/helpers.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-toolbar/sources/types.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/entry.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "vault.d.ts",
      ],
    },
  },
  gantt: {
    "gantt@default": "gantt@edge/dhtmlxgantt",
  },
  spreadsheet: {
    "spreadsheet@pro/edge/spreadsheet": {
      libName: "spreadsheet_5.2",
      basePath: "spreadsheet/pro/5.2",
      paths: [
        "spreadsheet.d.ts",
        "types/muon/data/copyManager.d.ts",
        "types/muon/data/page.d.ts",
        "types/muon/data/ranges.d.ts",
        "types/muon/data/store.d.ts",
        "types/muon/generators/excel.d.ts",
        "types/muon/generators/function.d.ts",
        "types/muon/generators/pretty.d.ts",
        "types/muon/helpers.d.ts",
        "types/muon/id.d.ts",
        "types/muon/index.d.ts",
        "types/muon/methods/dates.d.ts",
        "types/muon/methods/financial.d.ts",
        "types/muon/methods/helpers.d.ts",
        "types/muon/methods/index.d.ts",
        "types/muon/methods/information.d.ts",
        "types/muon/methods/logical.d.ts",
        "types/muon/methods/lookup.d.ts",
        "types/muon/methods/numbers.d.ts",
        "types/muon/methods/strings.d.ts",
        "types/muon/params.d.ts",
        "types/muon/parsers/excel.d.ts",
        "types/muon/store.d.ts",
        "types/muon/types.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/entry.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/input.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/locale.d.ts",
        "types/ts-common/newKeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/group.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/methods.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/avatar.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/fieldset.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/elements/ToggleButton.d.ts",
        "types/ts-form/sources/elements/ToggleGroup.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/ExtendedGrid.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/default.d.ts",
        "types/ts-grid/sources/helpers/dom.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/locales/en.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/common.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/group/panel.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-grid/sources/ui/SubRows.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/entry_pro.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-spreadsheet/sources/actions/ActionsManager.d.ts",
        "types/ts-spreadsheet/sources/actions/AddColumn.d.ts",
        "types/ts-spreadsheet/sources/actions/AddRow.d.ts",
        "types/ts-spreadsheet/sources/actions/AddSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/Clear.d.ts",
        "types/ts-spreadsheet/sources/actions/ClearSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteColumn.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteRow.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/Filter.d.ts",
        "types/ts-spreadsheet/sources/actions/FitCol.d.ts",
        "types/ts-spreadsheet/sources/actions/Freeze.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupAction.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupColAction.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupRowAction.d.ts",
        "types/ts-spreadsheet/sources/actions/Hide.d.ts",
        "types/ts-spreadsheet/sources/actions/InsertLink.d.ts",
        "types/ts-spreadsheet/sources/actions/LockCell.d.ts",
        "types/ts-spreadsheet/sources/actions/Merge.d.ts",
        "types/ts-spreadsheet/sources/actions/RemoveCellStyles.d.ts",
        "types/ts-spreadsheet/sources/actions/RenameSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/ResizeCol.d.ts",
        "types/ts-spreadsheet/sources/actions/ResizeRow.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellFormat.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellStyle.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellValue.d.ts",
        "types/ts-spreadsheet/sources/actions/SetValidation.d.ts",
        "types/ts-spreadsheet/sources/actions/SortCells.d.ts",
        "types/ts-spreadsheet/sources/actions/Unmerge.d.ts",
        "types/ts-spreadsheet/sources/configs/context.d.ts",
        "types/ts-spreadsheet/sources/configs/menu.d.ts",
        "types/ts-spreadsheet/sources/configs/toolbar.d.ts",
        "types/ts-spreadsheet/sources/EditLine.d.ts",
        "types/ts-spreadsheet/sources/editors/DateEditor.d.ts",
        "types/ts-spreadsheet/sources/editors/SelectEditor.d.ts",
        "types/ts-spreadsheet/sources/editors/TimeEditor.d.ts",
        "types/ts-spreadsheet/sources/EditPopup.d.ts",
        "types/ts-spreadsheet/sources/entry.d.ts",
        "types/ts-spreadsheet/sources/Exporter.d.ts",
        "types/ts-spreadsheet/sources/forms/FilterForm.d.ts",
        "types/ts-spreadsheet/sources/forms/LinkForm.d.ts",
        "types/ts-spreadsheet/sources/forms/Merge.d.ts",
        "types/ts-spreadsheet/sources/forms/SearchForm.d.ts",
        "types/ts-spreadsheet/sources/forms/ValidationForm.d.ts",
        "types/ts-spreadsheet/sources/helpers/actions.d.ts",
        "types/ts-spreadsheet/sources/helpers/buffer.d.ts",
        "types/ts-spreadsheet/sources/helpers/CustomCsvDriver.d.ts",
        "types/ts-spreadsheet/sources/helpers/date.d.ts",
        "types/ts-spreadsheet/sources/helpers/FileProxy.d.ts",
        "types/ts-spreadsheet/sources/helpers/format.d.ts",
        "types/ts-spreadsheet/sources/helpers/hotkeys.d.ts",
        "types/ts-spreadsheet/sources/helpers/main.d.ts",
        "types/ts-spreadsheet/sources/helpers/math.d.ts",
        "types/ts-spreadsheet/sources/helpers/selection.d.ts",
        "types/ts-spreadsheet/sources/helpers/toolbar.d.ts",
        "types/ts-spreadsheet/sources/helpers/XlsxDriver.d.ts",
        "types/ts-spreadsheet/sources/locales/en.d.ts",
        "types/ts-spreadsheet/sources/Selection.d.ts",
        "types/ts-spreadsheet/sources/Sheets.d.ts",
        "types/ts-spreadsheet/sources/Spreadsheet.d.ts",
        "types/ts-spreadsheet/sources/Store.d.ts",
        "types/ts-spreadsheet/sources/Toolbar.d.ts",
        "types/ts-spreadsheet/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/entry.d.ts",
        "types/ts-toolbar/sources/entry_pro.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-treegrid/index.d.ts",
        "types/ts-treegrid/sources/TreeGrid.d.ts",
        "types/ts-treegrid/sources/TreeGridCollection.d.ts",
        "types/ts-treegrid/sources/types.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts"
      ],
    },
    "spreadsheet@pro/5.1/spreadsheet": {
      libName: "spreadsheet_5.1",
      basePath: "spreadsheet/pro/5.1",
      paths: [
        "spreadsheet.d.ts",
        "types/muon/data/copyManager.d.ts",
        "types/muon/data/page.d.ts",
        "types/muon/data/ranges.d.ts",
        "types/muon/data/store.d.ts",
        "types/muon/generators/excel.d.ts",
        "types/muon/generators/function.d.ts",
        "types/muon/generators/pretty.d.ts",
        "types/muon/helpers.d.ts",
        "types/muon/id.d.ts",
        "types/muon/index.d.ts",
        "types/muon/methods/dates.d.ts",
        "types/muon/methods/financial.d.ts",
        "types/muon/methods/helpers.d.ts",
        "types/muon/methods/index.d.ts",
        "types/muon/methods/information.d.ts",
        "types/muon/methods/lookup.d.ts",
        "types/muon/methods/numbers.d.ts",
        "types/muon/methods/other.d.ts",
        "types/muon/methods/strings.d.ts",
        "types/muon/parsers/excel.d.ts",
        "types/muon/store.d.ts",
        "types/muon/types.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/newKeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-spreadsheet/sources/actions/ActionsManager.d.ts",
        "types/ts-spreadsheet/sources/actions/AddColumn.d.ts",
        "types/ts-spreadsheet/sources/actions/AddRow.d.ts",
        "types/ts-spreadsheet/sources/actions/AddSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/Clear.d.ts",
        "types/ts-spreadsheet/sources/actions/ClearSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteColumn.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteRow.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/Filter.d.ts",
        "types/ts-spreadsheet/sources/actions/FitCol.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupAction.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupColAction.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupRowAction.d.ts",
        "types/ts-spreadsheet/sources/actions/InsertLink.d.ts",
        "types/ts-spreadsheet/sources/actions/LockCell.d.ts",
        "types/ts-spreadsheet/sources/actions/Merge.d.ts",
        "types/ts-spreadsheet/sources/actions/RemoveCellStyles.d.ts",
        "types/ts-spreadsheet/sources/actions/RenameSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/ResizeCol.d.ts",
        "types/ts-spreadsheet/sources/actions/ResizeRow.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellFormat.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellStyle.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellValue.d.ts",
        "types/ts-spreadsheet/sources/actions/SetValidation.d.ts",
        "types/ts-spreadsheet/sources/actions/SortCells.d.ts",
        "types/ts-spreadsheet/sources/actions/Unmerge.d.ts",
        "types/ts-spreadsheet/sources/configs/context.d.ts",
        "types/ts-spreadsheet/sources/configs/menu.d.ts",
        "types/ts-spreadsheet/sources/configs/toolbar.d.ts",
        "types/ts-spreadsheet/sources/EditLine.d.ts",
        "types/ts-spreadsheet/sources/editors/DateEditor.d.ts",
        "types/ts-spreadsheet/sources/editors/SelectEditor.d.ts",
        "types/ts-spreadsheet/sources/editors/TimeEditor.d.ts",
        "types/ts-spreadsheet/sources/EditPopup.d.ts",
        "types/ts-spreadsheet/sources/entry.d.ts",
        "types/ts-spreadsheet/sources/Exporter.d.ts",
        "types/ts-spreadsheet/sources/forms/FilterForm.d.ts",
        "types/ts-spreadsheet/sources/forms/LinkForm.d.ts",
        "types/ts-spreadsheet/sources/forms/Merge.d.ts",
        "types/ts-spreadsheet/sources/forms/SearchForm.d.ts",
        "types/ts-spreadsheet/sources/forms/ValidationForm.d.ts",
        "types/ts-spreadsheet/sources/helpers/actions.d.ts",
        "types/ts-spreadsheet/sources/helpers/buffer.d.ts",
        "types/ts-spreadsheet/sources/helpers/CustomCsvDriver.d.ts",
        "types/ts-spreadsheet/sources/helpers/date.d.ts",
        "types/ts-spreadsheet/sources/helpers/FileProxy.d.ts",
        "types/ts-spreadsheet/sources/helpers/format.d.ts",
        "types/ts-spreadsheet/sources/helpers/hotkeys.d.ts",
        "types/ts-spreadsheet/sources/helpers/main.d.ts",
        "types/ts-spreadsheet/sources/helpers/math.d.ts",
        "types/ts-spreadsheet/sources/helpers/selection.d.ts",
        "types/ts-spreadsheet/sources/helpers/toolbar.d.ts",
        "types/ts-spreadsheet/sources/helpers/XlsxDriver.d.ts",
        "types/ts-spreadsheet/sources/locales/en.d.ts",
        "types/ts-spreadsheet/sources/Selection.d.ts",
        "types/ts-spreadsheet/sources/Spreadsheet.d.ts",
        "types/ts-spreadsheet/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts"
      ],
    },
    "spreadsheet@pro/5.0/spreadsheet": {
      libName: "spreadsheet_5.0",
      basePath: "spreadsheet/pro/5.0",
      paths: [
        "spreadsheet.d.ts",
        "types/muon/data/page.d.ts",
        "types/muon/data/ranges.d.ts",
        "types/muon/data/store.d.ts",
        "types/muon/generators/excel.d.ts",
        "types/muon/generators/function.d.ts",
        "types/muon/generators/pretty.d.ts",
        "types/muon/helpers.d.ts",
        "types/muon/id.d.ts",
        "types/muon/index.d.ts",
        "types/muon/methods/dates.d.ts",
        "types/muon/methods/financial.d.ts",
        "types/muon/methods/helpers.d.ts",
        "types/muon/methods/index.d.ts",
        "types/muon/methods/information.d.ts",
        "types/muon/methods/lookup.d.ts",
        "types/muon/methods/numbers.d.ts",
        "types/muon/methods/other.d.ts",
        "types/muon/methods/strings.d.ts",
        "types/muon/parsers/excel.d.ts",
        "types/muon/store.d.ts",
        "types/muon/types.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/newKeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-dataview/index.d.ts",
        "types/ts-dataview/sources/DataView.d.ts",
        "types/ts-dataview/sources/editors/editors.d.ts",
        "types/ts-dataview/sources/editors/InputEditor.d.ts",
        "types/ts-dataview/sources/ProDataView.d.ts",
        "types/ts-dataview/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/proCombo.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-spreadsheet/sources/actions/ActionsManager.d.ts",
        "types/ts-spreadsheet/sources/actions/AddColumn.d.ts",
        "types/ts-spreadsheet/sources/actions/AddRow.d.ts",
        "types/ts-spreadsheet/sources/actions/AddSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/Clear.d.ts",
        "types/ts-spreadsheet/sources/actions/ClearSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteColumn.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteRow.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/Filter.d.ts",
        "types/ts-spreadsheet/sources/actions/FitCol.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupAction.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupColAction.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupRowAction.d.ts",
        "types/ts-spreadsheet/sources/actions/InsertLink.d.ts",
        "types/ts-spreadsheet/sources/actions/LockCell.d.ts",
        "types/ts-spreadsheet/sources/actions/Merge.d.ts",
        "types/ts-spreadsheet/sources/actions/RemoveCellStyles.d.ts",
        "types/ts-spreadsheet/sources/actions/RenameSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/ResizeCol.d.ts",
        "types/ts-spreadsheet/sources/actions/ResizeRow.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellFormat.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellStyle.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellValue.d.ts",
        "types/ts-spreadsheet/sources/actions/SetValidation.d.ts",
        "types/ts-spreadsheet/sources/actions/SortCells.d.ts",
        "types/ts-spreadsheet/sources/actions/Unmerge.d.ts",
        "types/ts-spreadsheet/sources/configs/context.d.ts",
        "types/ts-spreadsheet/sources/configs/menu.d.ts",
        "types/ts-spreadsheet/sources/configs/toolbar.d.ts",
        "types/ts-spreadsheet/sources/EditLine.d.ts",
        "types/ts-spreadsheet/sources/editors/DateEditor.d.ts",
        "types/ts-spreadsheet/sources/editors/SelectEditor.d.ts",
        "types/ts-spreadsheet/sources/editors/TimeEditor.d.ts",
        "types/ts-spreadsheet/sources/EditPopup.d.ts",
        "types/ts-spreadsheet/sources/entry.d.ts",
        "types/ts-spreadsheet/sources/Exporter.d.ts",
        "types/ts-spreadsheet/sources/forms/FilterForm.d.ts",
        "types/ts-spreadsheet/sources/forms/LinkForm.d.ts",
        "types/ts-spreadsheet/sources/forms/Merge.d.ts",
        "types/ts-spreadsheet/sources/forms/SearchForm.d.ts",
        "types/ts-spreadsheet/sources/forms/ValidationForm.d.ts",
        "types/ts-spreadsheet/sources/helpers/actions.d.ts",
        "types/ts-spreadsheet/sources/helpers/buffer.d.ts",
        "types/ts-spreadsheet/sources/helpers/CustomCsvDriver.d.ts",
        "types/ts-spreadsheet/sources/helpers/date.d.ts",
        "types/ts-spreadsheet/sources/helpers/FileProxy.d.ts",
        "types/ts-spreadsheet/sources/helpers/format.d.ts",
        "types/ts-spreadsheet/sources/helpers/hotkeys.d.ts",
        "types/ts-spreadsheet/sources/helpers/main.d.ts",
        "types/ts-spreadsheet/sources/helpers/math.d.ts",
        "types/ts-spreadsheet/sources/helpers/selection.d.ts",
        "types/ts-spreadsheet/sources/helpers/toolbar.d.ts",
        "types/ts-spreadsheet/sources/helpers/XlsxDriver.d.ts",
        "types/ts-spreadsheet/sources/locales/en.d.ts",
        "types/ts-spreadsheet/sources/Selection.d.ts",
        "types/ts-spreadsheet/sources/Spreadsheet.d.ts",
        "types/ts-spreadsheet/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts",
      ],
    },
    "spreadsheet@pro/4.3/spreadsheet": {
      libName: "spreadsheet_4.3",
      basePath: "spreadsheet/pro/4.3",
      paths: [
        "spreadsheet.d.ts",
        "types/muon/data/page.d.ts",
        "types/muon/data/ranges.d.ts",
        "types/muon/data/store.d.ts",
        "types/muon/generators/excel.d.ts",
        "types/muon/generators/function.d.ts",
        "types/muon/generators/pretty.d.ts",
        "types/muon/helpers.d.ts",
        "types/muon/id.d.ts",
        "types/muon/index.d.ts",
        "types/muon/methods/dates.d.ts",
        "types/muon/methods/financial.d.ts",
        "types/muon/methods/helpers.d.ts",
        "types/muon/methods/index.d.ts",
        "types/muon/methods/information.d.ts",
        "types/muon/methods/lookup.d.ts",
        "types/muon/methods/numbers.d.ts",
        "types/muon/methods/other.d.ts",
        "types/muon/methods/strings.d.ts",
        "types/muon/parsers/excel.d.ts",
        "types/muon/store.d.ts",
        "types/muon/types.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/newKeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/proCombo.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-spreadsheet/sources/actions/ActionsManager.d.ts",
        "types/ts-spreadsheet/sources/actions/AddColumn.d.ts",
        "types/ts-spreadsheet/sources/actions/AddRow.d.ts",
        "types/ts-spreadsheet/sources/actions/AddSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/Clear.d.ts",
        "types/ts-spreadsheet/sources/actions/ClearSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteColumn.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteRow.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupAction.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupColAction.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupRowAction.d.ts",
        "types/ts-spreadsheet/sources/actions/LockCell.d.ts",
        "types/ts-spreadsheet/sources/actions/RemoveCellStyles.d.ts",
        "types/ts-spreadsheet/sources/actions/RenameSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/ResizeCol.d.ts",
        "types/ts-spreadsheet/sources/actions/ResizeRow.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellFormat.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellStyle.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellValue.d.ts",
        "types/ts-spreadsheet/sources/actions/SetValidation.d.ts",
        "types/ts-spreadsheet/sources/actions/SortCells.d.ts",
        "types/ts-spreadsheet/sources/configs/context.d.ts",
        "types/ts-spreadsheet/sources/configs/menu.d.ts",
        "types/ts-spreadsheet/sources/configs/toolbar.d.ts",
        "types/ts-spreadsheet/sources/EditLine.d.ts",
        "types/ts-spreadsheet/sources/editors/DateEditor.d.ts",
        "types/ts-spreadsheet/sources/editors/SelectEditor.d.ts",
        "types/ts-spreadsheet/sources/editors/TimeEditor.d.ts",
        "types/ts-spreadsheet/sources/EditPopup.d.ts",
        "types/ts-spreadsheet/sources/entry.d.ts",
        "types/ts-spreadsheet/sources/Exporter.d.ts",
        "types/ts-spreadsheet/sources/helpers/actions.d.ts",
        "types/ts-spreadsheet/sources/helpers/buffer.d.ts",
        "types/ts-spreadsheet/sources/helpers/CustomCsvDriver.d.ts",
        "types/ts-spreadsheet/sources/helpers/date.d.ts",
        "types/ts-spreadsheet/sources/helpers/FileProxy.d.ts",
        "types/ts-spreadsheet/sources/helpers/format.d.ts",
        "types/ts-spreadsheet/sources/helpers/hotkeys.d.ts",
        "types/ts-spreadsheet/sources/helpers/main.d.ts",
        "types/ts-spreadsheet/sources/helpers/math.d.ts",
        "types/ts-spreadsheet/sources/helpers/selection.d.ts",
        "types/ts-spreadsheet/sources/helpers/toolbar.d.ts",
        "types/ts-spreadsheet/sources/helpers/XlsxDriver.d.ts",
        "types/ts-spreadsheet/sources/locales/en.d.ts",
        "types/ts-spreadsheet/sources/Selection.d.ts",
        "types/ts-spreadsheet/sources/Spreadsheet.d.ts",
        "types/ts-spreadsheet/sources/types.d.ts",
        "types/ts-spreadsheet/sources/ValidationForm.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts",
      ],
    },
    "spreadsheet@pro/4.2/spreadsheet": {
      libName: "spreadsheet_4.2",
      basePath: "spreadsheet/pro/4.2",
      paths: [
        "spreadsheet.d.ts",
        "types/muon/data/page.d.ts",
        "types/muon/data/ranges.d.ts",
        "types/muon/data/store.d.ts",
        "types/muon/generators/excel.d.ts",
        "types/muon/generators/function.d.ts",
        "types/muon/generators/pretty.d.ts",
        "types/muon/helpers.d.ts",
        "types/muon/id.d.ts",
        "types/muon/index.d.ts",
        "types/muon/methods/dates.d.ts",
        "types/muon/methods/financial.d.ts",
        "types/muon/methods/helpers.d.ts",
        "types/muon/methods/index.d.ts",
        "types/muon/methods/information.d.ts",
        "types/muon/methods/numbers.d.ts",
        "types/muon/methods/other.d.ts",
        "types/muon/methods/strings.d.ts",
        "types/muon/parsers/excel.d.ts",
        "types/muon/store.d.ts",
        "types/muon/types.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/newKeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-spreadsheet/sources/actions/ActionsManager.d.ts",
        "types/ts-spreadsheet/sources/actions/AddColumn.d.ts",
        "types/ts-spreadsheet/sources/actions/AddRow.d.ts",
        "types/ts-spreadsheet/sources/actions/AddSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/Clear.d.ts",
        "types/ts-spreadsheet/sources/actions/ClearSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteColumn.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteRow.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupAction.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupColAction.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupRowAction.d.ts",
        "types/ts-spreadsheet/sources/actions/LockCell.d.ts",
        "types/ts-spreadsheet/sources/actions/RemoveCellStyles.d.ts",
        "types/ts-spreadsheet/sources/actions/RenameSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellFormat.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellStyle.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellValue.d.ts",
        "types/ts-spreadsheet/sources/configs/context.d.ts",
        "types/ts-spreadsheet/sources/configs/menu.d.ts",
        "types/ts-spreadsheet/sources/configs/toolbar.d.ts",
        "types/ts-spreadsheet/sources/EditLine.d.ts",
        "types/ts-spreadsheet/sources/editors/DateEditor.d.ts",
        "types/ts-spreadsheet/sources/EditPopup.d.ts",
        "types/ts-spreadsheet/sources/entry.d.ts",
        "types/ts-spreadsheet/sources/Exporter.d.ts",
        "types/ts-spreadsheet/sources/helpers/actions.d.ts",
        "types/ts-spreadsheet/sources/helpers/buffer.d.ts",
        "types/ts-spreadsheet/sources/helpers/CustomCsvDriver.d.ts",
        "types/ts-spreadsheet/sources/helpers/date.d.ts",
        "types/ts-spreadsheet/sources/helpers/format.d.ts",
        "types/ts-spreadsheet/sources/helpers/hotkeys.d.ts",
        "types/ts-spreadsheet/sources/helpers/main.d.ts",
        "types/ts-spreadsheet/sources/helpers/math.d.ts",
        "types/ts-spreadsheet/sources/helpers/selection.d.ts",
        "types/ts-spreadsheet/sources/helpers/toolbar.d.ts",
        "types/ts-spreadsheet/sources/helpers/XlsxDriver.d.ts",
        "types/ts-spreadsheet/sources/helpers/XlsxProxy.d.ts",
        "types/ts-spreadsheet/sources/locales/en.d.ts",
        "types/ts-spreadsheet/sources/Resizer.d.ts",
        "types/ts-spreadsheet/sources/Selection.d.ts",
        "types/ts-spreadsheet/sources/Spreadsheet.d.ts",
        "types/ts-spreadsheet/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/helpers.d.ts",
        "types/ts-window/sources/ProWindow.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts",
      ],
    },
    "spreadsheet@pro/4.1/spreadsheet": {
      libName: "spreadsheet_4.1",
      basePath: "spreadsheet/pro/4.1",
      paths: [
        "spreadsheet.d.ts",
        "types/muon/data/page.d.ts",
        "types/muon/data/ranges.d.ts",
        "types/muon/data/store.d.ts",
        "types/muon/data.d.ts",
        "types/muon/generators/excel.d.ts",
        "types/muon/generators/function.d.ts",
        "types/muon/generators/pretty.d.ts",
        "types/muon/helpers.d.ts",
        "types/muon/id.d.ts",
        "types/muon/index.d.ts",
        "types/muon/methods/dates.d.ts",
        "types/muon/methods/helpers.d.ts",
        "types/muon/methods/index.d.ts",
        "types/muon/methods/numbers.d.ts",
        "types/muon/methods/other.d.ts",
        "types/muon/methods/strings.d.ts",
        "types/muon/parsers/excel.d.ts",
        "types/muon/store.d.ts",
        "types/muon/types.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/newKeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-spreadsheet/sources/actions/ActionsManager.d.ts",
        "types/ts-spreadsheet/sources/actions/AddColumn.d.ts",
        "types/ts-spreadsheet/sources/actions/AddRow.d.ts",
        "types/ts-spreadsheet/sources/actions/AddSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteColumn.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteRow.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupAction.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupColAction.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupRowAction.d.ts",
        "types/ts-spreadsheet/sources/actions/LockCell.d.ts",
        "types/ts-spreadsheet/sources/actions/RemoveCellStyles.d.ts",
        "types/ts-spreadsheet/sources/actions/RenameSheet.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellFormat.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellStyle.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellValue.d.ts",
        "types/ts-spreadsheet/sources/columnsResizer.d.ts",
        "types/ts-spreadsheet/sources/configs/context.d.ts",
        "types/ts-spreadsheet/sources/configs/menu.d.ts",
        "types/ts-spreadsheet/sources/configs/toolbar.d.ts",
        "types/ts-spreadsheet/sources/EditLine.d.ts",
        "types/ts-spreadsheet/sources/EditPopup.d.ts",
        "types/ts-spreadsheet/sources/entry.d.ts",
        "types/ts-spreadsheet/sources/Exporter.d.ts",
        "types/ts-spreadsheet/sources/helpers/actions.d.ts",
        "types/ts-spreadsheet/sources/helpers/buffer.d.ts",
        "types/ts-spreadsheet/sources/helpers/CustomCsvDriver.d.ts",
        "types/ts-spreadsheet/sources/helpers/format.d.ts",
        "types/ts-spreadsheet/sources/helpers/hotkeys.d.ts",
        "types/ts-spreadsheet/sources/helpers/main.d.ts",
        "types/ts-spreadsheet/sources/helpers/math.d.ts",
        "types/ts-spreadsheet/sources/helpers/selection.d.ts",
        "types/ts-spreadsheet/sources/helpers/toolbar.d.ts",
        "types/ts-spreadsheet/sources/helpers/XlsxDriver.d.ts",
        "types/ts-spreadsheet/sources/helpers/XlsxProxy.d.ts",
        "types/ts-spreadsheet/sources/locales/en.d.ts",
        "types/ts-spreadsheet/sources/Selection.d.ts",
        "types/ts-spreadsheet/sources/Spreadsheet.d.ts",
        "types/ts-spreadsheet/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-window/index.d.ts",
        "types/ts-window/sources/types.d.ts",
        "types/ts-window/sources/Window.d.ts",
        "types/ts-window/sources/WindowController.d.ts",
      ],
    },
    "spreadsheet@pro/4.0/spreadsheet": {
      libName: "spreadsheet_4.0",
      basePath: "spreadsheet/pro/4.0",
      paths: [
        "spreadsheet.d.ts",
        "types/muon/data/page.d.ts",
        "types/muon/data/ranges.d.ts",
        "types/muon/data/store.d.ts",
        "types/muon/data.d.ts",
        "types/muon/generators/excel.d.ts",
        "types/muon/generators/function.d.ts",
        "types/muon/generators/pretty.d.ts",
        "types/muon/helpers.d.ts",
        "types/muon/id.d.ts",
        "types/muon/index.d.ts",
        "types/muon/methods/dates.d.ts",
        "types/muon/methods/helpers.d.ts",
        "types/muon/methods/index.d.ts",
        "types/muon/methods/numbers.d.ts",
        "types/muon/methods/other.d.ts",
        "types/muon/methods/strings.d.ts",
        "types/muon/parsers/excel.d.ts",
        "types/muon/store.d.ts",
        "types/muon/types.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/DateFormatter.d.ts",
        "types/ts-calendar/sources/DateHelper.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/locales/en.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/focus.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/Keymanager.d.ts",
        "types/ts-common/newKeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/KeyManager.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-spreadsheet/sources/actions/ActionsManager.d.ts",
        "types/ts-spreadsheet/sources/actions/AddColumn.d.ts",
        "types/ts-spreadsheet/sources/actions/AddRow.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteColumn.d.ts",
        "types/ts-spreadsheet/sources/actions/DeleteRow.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupAction.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupColAction.d.ts",
        "types/ts-spreadsheet/sources/actions/GroupRowAction.d.ts",
        "types/ts-spreadsheet/sources/actions/LockCell.d.ts",
        "types/ts-spreadsheet/sources/actions/RemoveCellStyles.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellFormat.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellStyle.d.ts",
        "types/ts-spreadsheet/sources/actions/SetCellValue.d.ts",
        "types/ts-spreadsheet/sources/columnsResizer.d.ts",
        "types/ts-spreadsheet/sources/configs/context.d.ts",
        "types/ts-spreadsheet/sources/configs/menu.d.ts",
        "types/ts-spreadsheet/sources/configs/toolbar.d.ts",
        "types/ts-spreadsheet/sources/EditLine.d.ts",
        "types/ts-spreadsheet/sources/EditPopup.d.ts",
        "types/ts-spreadsheet/sources/entry.d.ts",
        "types/ts-spreadsheet/sources/Exporter.d.ts",
        "types/ts-spreadsheet/sources/helpers/actions.d.ts",
        "types/ts-spreadsheet/sources/helpers/buffer.d.ts",
        "types/ts-spreadsheet/sources/helpers/CustomCsvDriver.d.ts",
        "types/ts-spreadsheet/sources/helpers/format.d.ts",
        "types/ts-spreadsheet/sources/helpers/hotkeys.d.ts",
        "types/ts-spreadsheet/sources/helpers/main.d.ts",
        "types/ts-spreadsheet/sources/helpers/math.d.ts",
        "types/ts-spreadsheet/sources/helpers/selection.d.ts",
        "types/ts-spreadsheet/sources/helpers/toolbar.d.ts",
        "types/ts-spreadsheet/sources/helpers/XlsxDriver.d.ts",
        "types/ts-spreadsheet/sources/helpers/XlsxProxy.d.ts",
        "types/ts-spreadsheet/sources/locales/en.d.ts",
        "types/ts-spreadsheet/sources/Selection.d.ts",
        "types/ts-spreadsheet/sources/Spreadsheet.d.ts",
        "types/ts-spreadsheet/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
      ],
    },
  },
  diagram: {
    "diagram@pro/edge/diagramWithEditor": {
      libName: "diagram_6.0",
      basePath: "diagram/pro/6.0",
      paths: [
        "diagram.d.ts",
        "diagramWithEditor.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/locale.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-diagram/index.d.ts",
        "types/ts-diagram/sources/components/BaseItem.d.ts",
        "types/ts-diagram/sources/components/Groups/BaseGroup.d.ts",
        "types/ts-diagram/sources/components/Groups/Group.d.ts",
        "types/ts-diagram/sources/components/Groups/GroupSwimlane.d.ts",
        "types/ts-diagram/sources/components/Lines/Line.d.ts",
        "types/ts-diagram/sources/components/Lines/LineTitle.d.ts",
        "types/ts-diagram/sources/components/shapeFactory.d.ts",
        "types/ts-diagram/sources/components/Shapes/BaseShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/Card.d.ts",
        "types/ts-diagram/sources/components/Shapes/CustomShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/FlowShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/ImgCard.d.ts",
        "types/ts-diagram/sources/components/Shapes/TextShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/TopicShape.d.ts",
        "types/ts-diagram/sources/components/Swimlane/Swimlane.d.ts",
        "types/ts-diagram/sources/components/templates/templates.d.ts",
        "types/ts-diagram/sources/Diagram.d.ts",
        "types/ts-diagram/sources/entry.d.ts",
        "types/ts-diagram/sources/entry_editor.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/Graph.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/layouts/Hola.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/layouts/Radial.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/layouts/SymmetricTree.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/Routes.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/compose.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/decompose.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/split.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/types.d.ts",
        "types/ts-diagram/sources/helpers/CellManager.d.ts",
        "types/ts-diagram/sources/helpers/Editor.d.ts",
        "types/ts-diagram/sources/helpers/Export.d.ts",
        "types/ts-diagram/sources/helpers/lineHelpers.d.ts",
        "types/ts-diagram/sources/helpers/linkPaths.d.ts",
        "types/ts-diagram/sources/helpers/placement/mindmap.d.ts",
        "types/ts-diagram/sources/helpers/placement/orgonogram.d.ts",
        "types/ts-diagram/sources/helpers/placement.d.ts",
        "types/ts-diagram/sources/helpers/Selection.d.ts",
        "types/ts-diagram/sources/locales/en.d.ts",
        "types/ts-diagram/sources/ShapesCollection.d.ts",
        "types/ts-diagram/sources/Toolbar.d.ts",
        "types/ts-diagram/sources/types.d.ts",
        "types/ts-diagram-editor/index.d.ts",
        "types/ts-diagram-editor/sources/BaseDiagramEditor.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/avatar.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/button.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/checkbox.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/checkboxGroup.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/colorpicker.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/combo.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/container.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/datepicker.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/fieldset.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/input.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/radioGroup.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/select.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/slider.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/spacer.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/textarea.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/timepicker.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/toggle.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/toggleGroup.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/common/helpers.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/common/label.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/arrange.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/border.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/gridStep.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/header.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/headerCommon.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/headerPosition.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/lineShape.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/pointerView.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/position.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/size.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/textAlign.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/textStyle.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/constants.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/index.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/properties.d.ts",
        "types/ts-diagram-editor/sources/configs/shapeToolbar.d.ts",
        "types/ts-diagram-editor/sources/configs/toolbar.d.ts",
        "types/ts-diagram-editor/sources/configs/view.d.ts",
        "types/ts-diagram-editor/sources/controls/connect.d.ts",
        "types/ts-diagram-editor/sources/controls/Controls.d.ts",
        "types/ts-diagram-editor/sources/controls/resize.d.ts",
        "types/ts-diagram-editor/sources/DefaultEditor.d.ts",
        "types/ts-diagram-editor/sources/helpers/common.d.ts",
        "types/ts-diagram-editor/sources/helpers/CopyManager.d.ts",
        "types/ts-diagram-editor/sources/helpers/drag.d.ts",
        "types/ts-diagram-editor/sources/helpers/HistoryManager.d.ts",
        "types/ts-diagram-editor/sources/helpers/SelectionBox.d.ts",
        "types/ts-diagram-editor/sources/OrgChartEditor.d.ts",
        "types/ts-diagram-editor/sources/types.d.ts",
        "types/ts-diagram-editor/sources/view/Editbar.d.ts",
        "types/ts-diagram-editor/sources/view/index.d.ts",
        "types/ts-diagram-editor/sources/view/Shapebar.d.ts",
        "types/ts-diagram-editor/sources/view/Toolbar.d.ts",
        "types/ts-diagram-editor/sources/view/View.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/avatar.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/fieldset.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/elements/ToggleButton.d.ts",
        "types/ts-form/sources/elements/ToggleGroup.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts"
      ],
    },
    "diagram@pro/6.0/diagramWithEditor": {
      libName: "diagram_6.0",
      basePath: "diagram/pro/6.0",
      paths: [
        "diagram.d.ts",
        "diagramWithEditor.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/locale.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-diagram/index.d.ts",
        "types/ts-diagram/sources/components/BaseItem.d.ts",
        "types/ts-diagram/sources/components/Groups/BaseGroup.d.ts",
        "types/ts-diagram/sources/components/Groups/Group.d.ts",
        "types/ts-diagram/sources/components/Groups/GroupSwimlane.d.ts",
        "types/ts-diagram/sources/components/Lines/Line.d.ts",
        "types/ts-diagram/sources/components/Lines/LineTitle.d.ts",
        "types/ts-diagram/sources/components/shapeFactory.d.ts",
        "types/ts-diagram/sources/components/Shapes/BaseShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/Card.d.ts",
        "types/ts-diagram/sources/components/Shapes/CustomShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/FlowShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/ImgCard.d.ts",
        "types/ts-diagram/sources/components/Shapes/TextShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/TopicShape.d.ts",
        "types/ts-diagram/sources/components/Swimlane/Swimlane.d.ts",
        "types/ts-diagram/sources/components/templates/templates.d.ts",
        "types/ts-diagram/sources/Diagram.d.ts",
        "types/ts-diagram/sources/entry.d.ts",
        "types/ts-diagram/sources/entry_editor.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/Graph.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/layouts/Hola.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/layouts/Radial.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/layouts/SymmetricTree.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/Routes.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/compose.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/decompose.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/split.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/types.d.ts",
        "types/ts-diagram/sources/helpers/CellManager.d.ts",
        "types/ts-diagram/sources/helpers/Editor.d.ts",
        "types/ts-diagram/sources/helpers/Export.d.ts",
        "types/ts-diagram/sources/helpers/lineHelpers.d.ts",
        "types/ts-diagram/sources/helpers/linkPaths.d.ts",
        "types/ts-diagram/sources/helpers/placement/mindmap.d.ts",
        "types/ts-diagram/sources/helpers/placement/orgonogram.d.ts",
        "types/ts-diagram/sources/helpers/placement.d.ts",
        "types/ts-diagram/sources/helpers/Selection.d.ts",
        "types/ts-diagram/sources/locales/en.d.ts",
        "types/ts-diagram/sources/ShapesCollection.d.ts",
        "types/ts-diagram/sources/Toolbar.d.ts",
        "types/ts-diagram/sources/types.d.ts",
        "types/ts-diagram-editor/index.d.ts",
        "types/ts-diagram-editor/sources/BaseDiagramEditor.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/avatar.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/button.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/checkbox.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/checkboxGroup.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/colorpicker.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/combo.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/container.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/datepicker.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/fieldset.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/input.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/radioGroup.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/select.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/slider.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/spacer.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/textarea.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/timepicker.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/toggle.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/basic/toggleGroup.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/common/helpers.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/common/label.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/arrange.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/border.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/gridStep.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/header.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/headerCommon.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/headerPosition.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/lineShape.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/pointerView.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/position.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/size.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/textAlign.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/complex/textStyle.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/constants.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/controls/index.d.ts",
        "types/ts-diagram-editor/sources/configs/editbar/properties.d.ts",
        "types/ts-diagram-editor/sources/configs/shapeToolbar.d.ts",
        "types/ts-diagram-editor/sources/configs/toolbar.d.ts",
        "types/ts-diagram-editor/sources/configs/view.d.ts",
        "types/ts-diagram-editor/sources/controls/connect.d.ts",
        "types/ts-diagram-editor/sources/controls/Controls.d.ts",
        "types/ts-diagram-editor/sources/controls/resize.d.ts",
        "types/ts-diagram-editor/sources/DefaultEditor.d.ts",
        "types/ts-diagram-editor/sources/helpers/common.d.ts",
        "types/ts-diagram-editor/sources/helpers/CopyManager.d.ts",
        "types/ts-diagram-editor/sources/helpers/drag.d.ts",
        "types/ts-diagram-editor/sources/helpers/HistoryManager.d.ts",
        "types/ts-diagram-editor/sources/helpers/SelectionBox.d.ts",
        "types/ts-diagram-editor/sources/OrgChartEditor.d.ts",
        "types/ts-diagram-editor/sources/types.d.ts",
        "types/ts-diagram-editor/sources/view/Editbar.d.ts",
        "types/ts-diagram-editor/sources/view/index.d.ts",
        "types/ts-diagram-editor/sources/view/Shapebar.d.ts",
        "types/ts-diagram-editor/sources/view/Toolbar.d.ts",
        "types/ts-diagram-editor/sources/view/View.d.ts",
        "types/ts-form/index.d.ts",
        "types/ts-form/sources/elements/avatar.d.ts",
        "types/ts-form/sources/elements/button.d.ts",
        "types/ts-form/sources/elements/checkbox.d.ts",
        "types/ts-form/sources/elements/checkboxGroup.d.ts",
        "types/ts-form/sources/elements/colorpicker.d.ts",
        "types/ts-form/sources/elements/combo.d.ts",
        "types/ts-form/sources/elements/container.d.ts",
        "types/ts-form/sources/elements/dateinput.d.ts",
        "types/ts-form/sources/elements/fieldset.d.ts",
        "types/ts-form/sources/elements/helper/label.d.ts",
        "types/ts-form/sources/elements/input.d.ts",
        "types/ts-form/sources/elements/radiobutton.d.ts",
        "types/ts-form/sources/elements/radioGroup.d.ts",
        "types/ts-form/sources/elements/select.d.ts",
        "types/ts-form/sources/elements/simplevault.d.ts",
        "types/ts-form/sources/elements/sliderform.d.ts",
        "types/ts-form/sources/elements/spacer.d.ts",
        "types/ts-form/sources/elements/textarea.d.ts",
        "types/ts-form/sources/elements/textinput.d.ts",
        "types/ts-form/sources/elements/timeinput.d.ts",
        "types/ts-form/sources/elements/ToggleButton.d.ts",
        "types/ts-form/sources/elements/ToggleGroup.d.ts",
        "types/ts-form/sources/Form.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/locales/en.d.ts",
        "types/ts-form/sources/ProForm.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content/ComboFilter.d.ts",
        "types/ts-grid/sources/ui/content/InputFilter.d.ts",
        "types/ts-grid/sources/ui/content/SelectFilter.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
        "types/ts-toolbar/index.d.ts",
        "types/ts-toolbar/sources/ProToolbar.d.ts",
        "types/ts-toolbar/sources/Toolbar.d.ts",
        "types/ts-vault/index.d.ts",
        "types/ts-vault/sources/configs.d.ts",
        "types/ts-vault/sources/helper.d.ts",
        "types/ts-vault/sources/locales/en.d.ts",
        "types/ts-vault/sources/ProgressBar.d.ts",
        "types/ts-vault/sources/ReadStackPreview.d.ts",
        "types/ts-vault/sources/types.d.ts",
        "types/ts-vault/sources/Uploader.d.ts",
        "types/ts-vault/sources/Vault.d.ts"
      ],
    },
    "diagram@pro/5.0/diagramWithEditor": {
      libName: "diagram_5.0",
      basePath: "diagram/pro/5.0",
      paths: [
        "diagramWithEditor.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-diagram/index.d.ts",
        "types/ts-diagram/sources/Diagram.d.ts",
        "types/ts-diagram/sources/ShapesCollection.d.ts",
        "types/ts-diagram/sources/Toolbar.d.ts",
        "types/ts-diagram/sources/components/BaseItem.d.ts",
        "types/ts-diagram/sources/components/Groups/BaseGroup.d.ts",
        "types/ts-diagram/sources/components/Groups/Group.d.ts",
        "types/ts-diagram/sources/components/Groups/GroupSwimlane.d.ts",
        "types/ts-diagram/sources/components/Lines/Line.d.ts",
        "types/ts-diagram/sources/components/Lines/LineText.d.ts",
        "types/ts-diagram/sources/components/Shapes/BaseShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/Card.d.ts",
        "types/ts-diagram/sources/components/Shapes/CustomShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/FlowShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/ImgCard.d.ts",
        "types/ts-diagram/sources/components/Shapes/TextShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/TopicShape.d.ts",
        "types/ts-diagram/sources/components/Swimlane/Swimlane.d.ts",
        "types/ts-diagram/sources/components/shapeFactory.d.ts",
        "types/ts-diagram/sources/components/templates/templates.d.ts",
        "types/ts-diagram/sources/entry.d.ts",
        "types/ts-diagram/sources/entry_editor.d.ts",
        "types/ts-diagram/sources/helpers/CellManager.d.ts",
        "types/ts-diagram/sources/helpers/Editor.d.ts",
        "types/ts-diagram/sources/helpers/Export.d.ts",
        "types/ts-diagram/sources/helpers/Selection.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/Graph.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/Routes.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/layouts/Hola.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/layouts/Radial.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/layouts/SymmetricTree.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/compose.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/decompose.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/split.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/types.d.ts",
        "types/ts-diagram/sources/helpers/baseMetaInfo.d.ts",
        "types/ts-diagram/sources/helpers/lineHelpers.d.ts",
        "types/ts-diagram/sources/helpers/linkPaths.d.ts",
        "types/ts-diagram/sources/helpers/placement/mindmap.d.ts",
        "types/ts-diagram/sources/helpers/placement/orgonogram.d.ts",
        "types/ts-diagram/sources/helpers/placement.d.ts",
        "types/ts-diagram/sources/locales/en.d.ts",
        "types/ts-diagram/sources/types.d.ts",
        "types/ts-diagram-editor/index.d.ts",
        "types/ts-diagram-editor/sources/BaseDiagramEditor.d.ts",
        "types/ts-diagram-editor/sources/BlockSelection.d.ts",
        "types/ts-diagram-editor/sources/FreeEditor.d.ts",
        "types/ts-diagram-editor/sources/HistoryManager.d.ts",
        "types/ts-diagram-editor/sources/OrgChartEditor.d.ts",
        "types/ts-diagram-editor/sources/SelectionBox.d.ts",
        "types/ts-diagram-editor/sources/ShapesBar.d.ts",
        "types/ts-diagram-editor/sources/Sidebar.d.ts",
        "types/ts-diagram-editor/sources/configs/icons.d.ts",
        "types/ts-diagram-editor/sources/configs/toolbar.d.ts",
        "types/ts-diagram-editor/sources/controls/Controls.d.ts",
        "types/ts-diagram-editor/sources/controls/connect.d.ts",
        "types/ts-diagram-editor/sources/controls/resize.d.ts",
        "types/ts-diagram-editor/sources/helpers/drag.d.ts",
        "types/ts-diagram-editor/sources/helpers/topbar.d.ts",
        "types/ts-diagram-editor/sources/property-module/Property.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/AlignBar.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/ColorPicker.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/EmptyState.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Enable.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Group.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/HeaderPosition.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Inputs.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/InputsGroup.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Label.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Select.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Stroke.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/StrokeGroup.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Text.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/TextProps.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Textarea.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Uploader.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/helpers.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/index.d.ts",
        "types/ts-diagram-editor/sources/property-module/types.d.ts",
        "types/ts-diagram-editor/sources/property-module/validate.d.ts",
        "types/ts-diagram-editor/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
      ],
    },
    "diagram@pro/4.2/diagramWithEditor": {
      libName: "diagram_4.2",
      basePath: "diagram/pro/4.2",
      paths: [
        "diagramWithEditor.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-diagram/index.d.ts",
        "types/ts-diagram/sources/Diagram.d.ts",
        "types/ts-diagram/sources/ShapesCollection.d.ts",
        "types/ts-diagram/sources/Toolbar.d.ts",
        "types/ts-diagram/sources/components/BaseItem.d.ts",
        "types/ts-diagram/sources/components/Groups/BaseGroup.d.ts",
        "types/ts-diagram/sources/components/Groups/Group.d.ts",
        "types/ts-diagram/sources/components/Groups/GroupSwimlane.d.ts",
        "types/ts-diagram/sources/components/Lines/Line.d.ts",
        "types/ts-diagram/sources/components/Lines/LineText.d.ts",
        "types/ts-diagram/sources/components/Shapes/BaseShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/Card.d.ts",
        "types/ts-diagram/sources/components/Shapes/CustomShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/FlowShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/ImgCard.d.ts",
        "types/ts-diagram/sources/components/Shapes/TextShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/TopicShape.d.ts",
        "types/ts-diagram/sources/components/Swimlane/Swimlane.d.ts",
        "types/ts-diagram/sources/components/shapeFactory.d.ts",
        "types/ts-diagram/sources/components/templates/templates.d.ts",
        "types/ts-diagram/sources/entry.d.ts",
        "types/ts-diagram/sources/entry_editor.d.ts",
        "types/ts-diagram/sources/helpers/CellManager.d.ts",
        "types/ts-diagram/sources/helpers/Editor.d.ts",
        "types/ts-diagram/sources/helpers/Export.d.ts",
        "types/ts-diagram/sources/helpers/Selection.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/Graph.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/Routes.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/layouts/Hola.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/layouts/SymmetricTree.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/compose.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/decompose.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/split.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/types.d.ts",
        "types/ts-diagram/sources/helpers/baseMetaInfo.d.ts",
        "types/ts-diagram/sources/helpers/lineHelpers.d.ts",
        "types/ts-diagram/sources/helpers/linkPaths.d.ts",
        "types/ts-diagram/sources/helpers/placement/mindmap.d.ts",
        "types/ts-diagram/sources/helpers/placement/orgonogram.d.ts",
        "types/ts-diagram/sources/helpers/placement.d.ts",
        "types/ts-diagram/sources/locales/en.d.ts",
        "types/ts-diagram/sources/types.d.ts",
        "types/ts-diagram-editor/index.d.ts",
        "types/ts-diagram-editor/sources/BaseDiagramEditor.d.ts",
        "types/ts-diagram-editor/sources/BlockSelection.d.ts",
        "types/ts-diagram-editor/sources/FreeEditor.d.ts",
        "types/ts-diagram-editor/sources/HistoryManager.d.ts",
        "types/ts-diagram-editor/sources/OrgChartEditor.d.ts",
        "types/ts-diagram-editor/sources/SelectionBox.d.ts",
        "types/ts-diagram-editor/sources/ShapesBar.d.ts",
        "types/ts-diagram-editor/sources/Sidebar.d.ts",
        "types/ts-diagram-editor/sources/configs/icons.d.ts",
        "types/ts-diagram-editor/sources/configs/toolbar.d.ts",
        "types/ts-diagram-editor/sources/controls/Controls.d.ts",
        "types/ts-diagram-editor/sources/controls/connect.d.ts",
        "types/ts-diagram-editor/sources/controls/resize.d.ts",
        "types/ts-diagram-editor/sources/helpers/drag.d.ts",
        "types/ts-diagram-editor/sources/helpers/topbar.d.ts",
        "types/ts-diagram-editor/sources/property-module/Property.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/AlignBar.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/ColorPicker.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/EmptyState.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Enable.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Group.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/HeaderPosition.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Inputs.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/InputsGroup.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Label.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Select.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Stroke.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/StrokeGroup.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Text.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/TextProps.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Textarea.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Uploader.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/helpers.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/index.d.ts",
        "types/ts-diagram-editor/sources/property-module/types.d.ts",
        "types/ts-diagram-editor/sources/property-module/validate.d.ts",
        "types/ts-diagram-editor/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
      ],
    },
    "diagram@pro/4.1/diagramWithEditor": {
      libName: "diagram_4.1",
      basePath: "diagram/pro/4.1",
      paths: [
        "diagramWithEditor.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-diagram/index.d.ts",
        "types/ts-diagram/sources/components/BaseItem.d.ts",
        "types/ts-diagram/sources/components/Groups/BaseGroup.d.ts",
        "types/ts-diagram/sources/components/Groups/Group.d.ts",
        "types/ts-diagram/sources/components/Groups/GroupSwimlane.d.ts",
        "types/ts-diagram/sources/components/Lines/Line.d.ts",
        "types/ts-diagram/sources/components/Lines/LineText.d.ts",
        "types/ts-diagram/sources/components/shapeFactory.d.ts",
        "types/ts-diagram/sources/components/Shapes/BaseShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/Card.d.ts",
        "types/ts-diagram/sources/components/Shapes/CustomShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/FlowShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/ImgCard.d.ts",
        "types/ts-diagram/sources/components/Shapes/TextShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/TopicShape.d.ts",
        "types/ts-diagram/sources/components/Swimlane/Swimlane.d.ts",
        "types/ts-diagram/sources/components/templates/templates.d.ts",
        "types/ts-diagram/sources/Diagram.d.ts",
        "types/ts-diagram/sources/entry.d.ts",
        "types/ts-diagram/sources/entry_editor.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/Graph.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/layouts/Hola.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/layouts/SymmetricTree.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/Routes.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/compose.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/decompose.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/split.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/types.d.ts",
        "types/ts-diagram/sources/helpers/baseMetaInfo.d.ts",
        "types/ts-diagram/sources/helpers/CellManager.d.ts",
        "types/ts-diagram/sources/helpers/Editor.d.ts",
        "types/ts-diagram/sources/helpers/Export.d.ts",
        "types/ts-diagram/sources/helpers/lineHelpers.d.ts",
        "types/ts-diagram/sources/helpers/linkPaths.d.ts",
        "types/ts-diagram/sources/helpers/placement/mindmap.d.ts",
        "types/ts-diagram/sources/helpers/placement/orgonogram.d.ts",
        "types/ts-diagram/sources/helpers/placement.d.ts",
        "types/ts-diagram/sources/helpers/Selection.d.ts",
        "types/ts-diagram/sources/locales/en.d.ts",
        "types/ts-diagram/sources/ShapesCollection.d.ts",
        "types/ts-diagram/sources/Toolbar.d.ts",
        "types/ts-diagram/sources/types.d.ts",
        "types/ts-diagram-editor/index.d.ts",
        "types/ts-diagram-editor/sources/BaseDiagramEditor.d.ts",
        "types/ts-diagram-editor/sources/BlockSelection.d.ts",
        "types/ts-diagram-editor/sources/configs/icons.d.ts",
        "types/ts-diagram-editor/sources/configs/toolbar.d.ts",
        "types/ts-diagram-editor/sources/controls/connect.d.ts",
        "types/ts-diagram-editor/sources/controls/Controls.d.ts",
        "types/ts-diagram-editor/sources/controls/resize.d.ts",
        "types/ts-diagram-editor/sources/FreeEditor.d.ts",
        "types/ts-diagram-editor/sources/helpers/drag.d.ts",
        "types/ts-diagram-editor/sources/helpers/topbar.d.ts",
        "types/ts-diagram-editor/sources/HistoryManager.d.ts",
        "types/ts-diagram-editor/sources/OrgChartEditor.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/AlignBar.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/ColorPicker.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/EmptyState.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Enable.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Group.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/HeaderPosition.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/helpers.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/index.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Inputs.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/InputsGroup.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Label.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Select.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Stroke.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/StrokeGroup.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Text.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Textarea.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/TextProps.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Uploader.d.ts",
        "types/ts-diagram-editor/sources/property-module/Property.d.ts",
        "types/ts-diagram-editor/sources/property-module/types.d.ts",
        "types/ts-diagram-editor/sources/property-module/validate.d.ts",
        "types/ts-diagram-editor/sources/SelectionBox.d.ts",
        "types/ts-diagram-editor/sources/ShapesBar.d.ts",
        "types/ts-diagram-editor/sources/Sidebar.d.ts",
        "types/ts-diagram-editor/sources/types.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
      ],
    },
    "diagram@pro/4.0/diagramWithEditor": {
      libName: "diagram_4.0",
      basePath: "diagram/pro/4.0",
      paths: [
        "diagramWithEditor.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/ProCombobox.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/ScrollView.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-diagram/index.d.ts",
        "types/ts-diagram/sources/components/BaseComponents.d.ts",
        "types/ts-diagram/sources/components/Groups/BaseGroup.d.ts",
        "types/ts-diagram/sources/components/Groups/Group.d.ts",
        "types/ts-diagram/sources/components/Groups/GroupSwimlane.d.ts",
        "types/ts-diagram/sources/components/Lines/Line.d.ts",
        "types/ts-diagram/sources/components/shapeFactory.d.ts",
        "types/ts-diagram/sources/components/Shapes/BaseShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/Card.d.ts",
        "types/ts-diagram/sources/components/Shapes/CustomShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/FlowShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/ImgCard.d.ts",
        "types/ts-diagram/sources/components/Shapes/TextShape.d.ts",
        "types/ts-diagram/sources/components/Shapes/TopicShape.d.ts",
        "types/ts-diagram/sources/components/Swimlane/Swimlane.d.ts",
        "types/ts-diagram/sources/components/templates/templates.d.ts",
        "types/ts-diagram/sources/Diagram.d.ts",
        "types/ts-diagram/sources/entry.d.ts",
        "types/ts-diagram/sources/entry_editor.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/Graph.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/layouts/Hola.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/layouts/SymmetricTree.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/Routes.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/compose.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/decompose.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/split.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/types.d.ts",
        "types/ts-diagram/sources/helpers/baseMetaInfo.d.ts",
        "types/ts-diagram/sources/helpers/CellManager.d.ts",
        "types/ts-diagram/sources/helpers/Editor.d.ts",
        "types/ts-diagram/sources/helpers/Export.d.ts",
        "types/ts-diagram/sources/helpers/linkPaths.d.ts",
        "types/ts-diagram/sources/helpers/placement/mindmap.d.ts",
        "types/ts-diagram/sources/helpers/placement/orgonogram.d.ts",
        "types/ts-diagram/sources/helpers/placement.d.ts",
        "types/ts-diagram/sources/helpers/Selection.d.ts",
        "types/ts-diagram/sources/locales/en.d.ts",
        "types/ts-diagram/sources/ShapesCollection.d.ts",
        "types/ts-diagram/sources/Toolbar.d.ts",
        "types/ts-diagram/sources/types.d.ts",
        "types/ts-diagram-editor/index.d.ts",
        "types/ts-diagram-editor/sources/BaseDiagramEditor.d.ts",
        "types/ts-diagram-editor/sources/BlockSelection.d.ts",
        "types/ts-diagram-editor/sources/configs/icons.d.ts",
        "types/ts-diagram-editor/sources/configs/toolbar.d.ts",
        "types/ts-diagram-editor/sources/controls/connect.d.ts",
        "types/ts-diagram-editor/sources/controls/Controls.d.ts",
        "types/ts-diagram-editor/sources/controls/resize.d.ts",
        "types/ts-diagram-editor/sources/FreeEditor.d.ts",
        "types/ts-diagram-editor/sources/helpers/drag.d.ts",
        "types/ts-diagram-editor/sources/helpers/topbar.d.ts",
        "types/ts-diagram-editor/sources/OrgChartEditor.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/AlignBar.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/ColorPicker.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/EmptyState.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Enable.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Group.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/HeaderPosition.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/helpers.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/index.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Inputs.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/InputsGroup.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Label.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Select.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Stroke.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/StrokeGroup.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Text.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Textarea.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/TextProps.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Uploader.d.ts",
        "types/ts-diagram-editor/sources/property-module/Property.d.ts",
        "types/ts-diagram-editor/sources/property-module/types.d.ts",
        "types/ts-diagram-editor/sources/property-module/validate.d.ts",
        "types/ts-diagram-editor/sources/SelectionBox.d.ts",
        "types/ts-diagram-editor/sources/ShapesBar.d.ts",
        "types/ts-diagram-editor/sources/Sidebar.d.ts",
        "types/ts-diagram-editor/sources/types.d.ts",
        "types/ts-diagram-editor/sources/UndoManager.d.ts",
        "types/ts-grid/index.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/ProCell.d.ts",
        "types/ts-layout/sources/ProLayout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/ProList.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-menu/index.d.ts",
        "types/ts-menu/sources/ContextMenu.d.ts",
        "types/ts-menu/sources/Menu.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-navbar/index.d.ts",
        "types/ts-navbar/sources/elements/button.d.ts",
        "types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "types/ts-navbar/sources/elements/datePicker.d.ts",
        "types/ts-navbar/sources/elements/helpers.d.ts",
        "types/ts-navbar/sources/elements/imageButton.d.ts",
        "types/ts-navbar/sources/elements/input.d.ts",
        "types/ts-navbar/sources/elements/menuItem.d.ts",
        "types/ts-navbar/sources/elements/navItem.d.ts",
        "types/ts-navbar/sources/elements/separator.d.ts",
        "types/ts-navbar/sources/elements/spacer.d.ts",
        "types/ts-navbar/sources/elements/title.d.ts",
        "types/ts-navbar/sources/itemfactory.d.ts",
        "types/ts-navbar/sources/Navbar.d.ts",
        "types/ts-navbar/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
      ],
    },
    "diagram@pro/3.1/diagramWithEditor": {
      libName: "diagram_3.1",
      basePath: "diagram/pro/3.1",
      paths: [
        "diagramWithEditor.d.ts",
        "types/ts-calendar/index.d.ts",
        "types/ts-calendar/sources/Calendar.d.ts",
        "types/ts-calendar/sources/helper.d.ts",
        "types/ts-calendar/sources/types.d.ts",
        "types/ts-colorpicker/index.d.ts",
        "types/ts-colorpicker/sources/Colorpicker.d.ts",
        "types/ts-colorpicker/sources/colors.d.ts",
        "types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "types/ts-colorpicker/sources/helpers/color.d.ts",
        "types/ts-colorpicker/sources/locales/en.d.ts",
        "types/ts-colorpicker/sources/picker.d.ts",
        "types/ts-colorpicker/sources/types.d.ts",
        "types/ts-combobox/index.d.ts",
        "types/ts-combobox/sources/Combobox.d.ts",
        "types/ts-combobox/sources/helper.d.ts",
        "types/ts-combobox/sources/keyListener.d.ts",
        "types/ts-combobox/sources/locales/en.d.ts",
        "types/ts-combobox/sources/types.d.ts",
        "types/ts-common/core.d.ts",
        "types/ts-common/CssManager.d.ts",
        "types/ts-common/date.d.ts",
        "types/ts-common/dom.d.ts",
        "types/ts-common/events.d.ts",
        "types/ts-common/FocusManager.d.ts",
        "types/ts-common/html.d.ts",
        "types/ts-common/keycodes.d.ts",
        "types/ts-common/KeyManager.d.ts",
        "types/ts-common/polyfills/array.d.ts",
        "types/ts-common/polyfills/element.d.ts",
        "types/ts-common/polyfills/math.d.ts",
        "types/ts-common/polyfills/object.d.ts",
        "types/ts-common/polyfills/string.d.ts",
        "types/ts-common/types.d.ts",
        "types/ts-common/view.d.ts",
        "types/ts-data/index.d.ts",
        "types/ts-data/sources/ajax.d.ts",
        "types/ts-data/sources/CollectionStore.d.ts",
        "types/ts-data/sources/datacollection/loader.d.ts",
        "types/ts-data/sources/datacollection/sort.d.ts",
        "types/ts-data/sources/datacollection.d.ts",
        "types/ts-data/sources/dataproxy.d.ts",
        "types/ts-data/sources/DragManager.d.ts",
        "types/ts-data/sources/drivers/CsvDriver.d.ts",
        "types/ts-data/sources/drivers/drivers.d.ts",
        "types/ts-data/sources/drivers/JsonDriver.d.ts",
        "types/ts-data/sources/drivers/XMLDriver.d.ts",
        "types/ts-data/sources/helpers.d.ts",
        "types/ts-data/sources/lazydataproxy.d.ts",
        "types/ts-data/sources/selection.d.ts",
        "types/ts-data/sources/serializers/xml.d.ts",
        "types/ts-data/sources/treecollection.d.ts",
        "types/ts-data/sources/types.d.ts",
        "types/ts-diagram/index.d.ts",
        "types/ts-diagram/sources/Diagram.d.ts",
        "types/ts-diagram/sources/entry.d.ts",
        "types/ts-diagram/sources/entry_editor.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/Graph.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/layouts/Hola.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/layouts/SymmetricTree.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/Routes.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/compose.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/decompose.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/tasks/split.d.ts",
        "types/ts-diagram/sources/helpers/autoplacement/types.d.ts",
        "types/ts-diagram/sources/helpers/baseMetaInfo.d.ts",
        "types/ts-diagram/sources/helpers/Export.d.ts",
        "types/ts-diagram/sources/helpers/linkPaths.d.ts",
        "types/ts-diagram/sources/helpers/placement/mindmap.d.ts",
        "types/ts-diagram/sources/helpers/placement/orgonogram.d.ts",
        "types/ts-diagram/sources/helpers/placement.d.ts",
        "types/ts-diagram/sources/helpers/Selection.d.ts",
        "types/ts-diagram/sources/locales/en.d.ts",
        "types/ts-diagram/sources/shapes/Base.d.ts",
        "types/ts-diagram/sources/shapes/Connector/Line.d.ts",
        "types/ts-diagram/sources/shapes/Diagram/DiagramCustomShape.d.ts",
        "types/ts-diagram/sources/shapes/Diagram/DiagramFlowShape.d.ts",
        "types/ts-diagram/sources/shapes/Diagram/DiagramTextShape.d.ts",
        "types/ts-diagram/sources/shapes/Diagram/DiagramTopicShape.d.ts",
        "types/ts-diagram/sources/shapes/factory.d.ts",
        "types/ts-diagram/sources/shapes/OrgChart/OrgChartCard.d.ts",
        "types/ts-diagram/sources/shapes/OrgChart/OrgChartImgCard.d.ts",
        "types/ts-diagram/sources/shapes/templates.d.ts",
        "types/ts-diagram/sources/ShapesCollection.d.ts",
        "types/ts-diagram/sources/Toolbar.d.ts",
        "types/ts-diagram/sources/types.d.ts",
        "types/ts-diagram-editor/index.d.ts",
        "types/ts-diagram-editor/sources/BaseDiagramEditor.d.ts",
        "types/ts-diagram-editor/sources/BlockSelection.d.ts",
        "types/ts-diagram-editor/sources/configs/icons.d.ts",
        "types/ts-diagram-editor/sources/configs/toolbar.d.ts",
        "types/ts-diagram-editor/sources/controls/connect.d.ts",
        "types/ts-diagram-editor/sources/controls/Controls.d.ts",
        "types/ts-diagram-editor/sources/controls/resize.d.ts",
        "types/ts-diagram-editor/sources/FreeEditor.d.ts",
        "types/ts-diagram-editor/sources/helpers/drag.d.ts",
        "types/ts-diagram-editor/sources/helpers/topbar.d.ts",
        "types/ts-diagram-editor/sources/OrgChartEditor.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/AlignBar.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/ColorPicker.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/EmptyState.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Group.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/helpers.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/index.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Inputs.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/InputsGroup.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Label.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Select.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Stroke.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Text.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Textarea.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/TextProps.d.ts",
        "types/ts-diagram-editor/sources/property-module/items/Uploader.d.ts",
        "types/ts-diagram-editor/sources/property-module/Property.d.ts",
        "types/ts-diagram-editor/sources/property-module/types.d.ts",
        "types/ts-diagram-editor/sources/property-module/validate.d.ts",
        "types/ts-diagram-editor/sources/SelectionBox.d.ts",
        "types/ts-diagram-editor/sources/ShapesBar.d.ts",
        "types/ts-diagram-editor/sources/Sidebar.d.ts",
        "types/ts-diagram-editor/sources/types.d.ts",
        "types/ts-diagram-editor/sources/UndoManager.d.ts",
        "types/ts-form/sources/helper.d.ts",
        "types/ts-form/sources/types.d.ts",
        "types/ts-grid/sources/columnsResizer.d.ts",
        "types/ts-grid/sources/Exporter.d.ts",
        "types/ts-grid/sources/Grid.d.ts",
        "types/ts-grid/sources/helpers/cells.d.ts",
        "types/ts-grid/sources/helpers/data.d.ts",
        "types/ts-grid/sources/helpers/keys.d.ts",
        "types/ts-grid/sources/helpers/main.d.ts",
        "types/ts-grid/sources/ProGrid.d.ts",
        "types/ts-grid/sources/Selection.d.ts",
        "types/ts-grid/sources/types.d.ts",
        "types/ts-grid/sources/ui/Cells.d.ts",
        "types/ts-grid/sources/ui/content.d.ts",
        "types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "types/ts-grid/sources/ui/editors/editors.d.ts",
        "types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "types/ts-grid/sources/ui/FixedCols.d.ts",
        "types/ts-grid/sources/ui/FixedRows.d.ts",
        "types/ts-grid/sources/ui/render.d.ts",
        "types/ts-layout/index.d.ts",
        "types/ts-layout/sources/Cell.d.ts",
        "types/ts-layout/sources/helpers.d.ts",
        "types/ts-layout/sources/Layout.d.ts",
        "types/ts-layout/sources/types.d.ts",
        "types/ts-list/index.d.ts",
        "types/ts-list/sources/editors/editors.d.ts",
        "types/ts-list/sources/editors/InputEditor.d.ts",
        "types/ts-list/sources/List.d.ts",
        "types/ts-list/sources/Selection.d.ts",
        "types/ts-list/sources/types.d.ts",
        "types/ts-message/index.d.ts",
        "types/ts-message/sources/alert.d.ts",
        "types/ts-message/sources/common.d.ts",
        "types/ts-message/sources/confirm.d.ts",
        "types/ts-message/sources/locales/en.d.ts",
        "types/ts-message/sources/message.d.ts",
        "types/ts-message/sources/tooltip.d.ts",
        "types/ts-message/sources/types.d.ts",
        "types/ts-popup/index.d.ts",
        "types/ts-popup/sources/Popup.d.ts",
        "types/ts-popup/sources/types.d.ts",
        "types/ts-slider/index.d.ts",
        "types/ts-slider/sources/Slider.d.ts",
        "types/ts-slider/sources/types.d.ts",
        "types/ts-timepicker/index.d.ts",
        "types/ts-timepicker/sources/helper.d.ts",
        "types/ts-timepicker/sources/locales/en.d.ts",
        "types/ts-timepicker/sources/Timepicker.d.ts",
        "types/ts-timepicker/sources/types.d.ts",
      ],
    },
  },
  booking: {
    "booking@pro/edge/booking": {
      libName: "booking_1.1",
      basePath: "booking/pro/1.1",
      paths: ["booking.d.ts"],
    },
    "booking@pro/1.0/booking": {
      libName: "booking_1.0",
      basePath: "booking/pro/1.0",
      paths: ["booking.d.ts"],
    },
  },
  kanban: {
    "kanban@pro/edge/kanban": {
      libName: "kanban_1.6",
      basePath: "kanban/pro/1.6",
      paths: ["kanban.d.ts"],
    },
    "kanban@pro/1.5/kanban": {
      libName: "kanban_1.5",
      basePath: "kanban/pro/1.5",
      paths: ["kanban.d.ts"],
    },
    "kanban@pro/1.4/kanban": {
      libName: "kanban_1.4",
      basePath: "kanban/pro/1.4",
      paths: ["kanban.d.ts"],
    },
    "kanban@pro/1.3/kanban": {
      libName: "kanban_1.3",
      basePath: "kanban/pro/1.3",
      paths: ["kanban.d.ts"],
    },
    "kanban@pro/1.2/kanban": {
      libName: "kanban_1.2",
      basePath: "kanban/pro/1.2",
      paths: ["kanban.d.ts"],
    },
    "kanban@pro/1.1/kanban": {
      libName: "kanban_1.1",
      basePath: "kanban/pro/1.1",
      paths: ["kanban.d.ts"],
    },
  },
  todo: {
    "todo@pro/edge/todo": {
      libName: "todo_1.3",
      basePath: "todo/pro/1.3",
      paths: ["todo.d.ts"],
    },
    "todo@pro/1.2/todo": {
      libName: "todo_1.2",
      basePath: "todo/pro/1.2",
      paths: ["todo.d.ts"],
    },
    "todo@pro/1.1/todo": {
      libName: "todo_1.1",
      basePath: "todo/pro/1.1",
      paths: ["todo.d.ts"],
    },
    "todo@pro/1.0/todo": {
      libName: "todo_1.0",
      basePath: "todo/pro/1.0",
      paths: ["todo.d.ts"],
    },
  },
  "event-calendar": {
    "event-calendar@pro/edge/event-calendar": {
      libName: "event-calendar_2.0",
      basePath: "event-calendar/pro/2.0",
      paths: [
        "event-calendar.d.ts",
        "types/EventCalendar.d.ts",
        "types/Events.d.ts",
        "types/index.d.ts",
      ],
    },
    "event-calendar@pro/1.1/event-calendar": {
      libName: "event-calendar_1.1",
      basePath: "event-calendar/pro/1.1",
      paths: [
        "event-calendar.d.ts",
        "types/EventCalendar.d.ts",
        "types/Events.d.ts",
        "types/index.d.ts",
      ],
    },
    "event-calendar@pro/1.0/event-calendar": {
      libName: "event-calendar_1.0",
      basePath: "event-calendar/pro/1.0",
      paths: [
        "event-calendar.d.ts",
        "types/EventCalendar.d.ts",
        "types/Events.d.ts",
        "types/index.d.ts",
      ],
    },
  },
  richtext: {
    "richtext@pro/edge/richtext": {
      libName: "richtext_1.2",
      basePath: "richtext/pro/1.2",
      paths: [
        "/richtext.d.ts",
        "/types/ts-calendar/index.d.ts",
        "/types/ts-calendar/sources/Calendar.d.ts",
        "/types/ts-calendar/sources/helper.d.ts",
        "/types/ts-calendar/sources/types.d.ts",
        "/types/ts-colorpicker/index.d.ts",
        "/types/ts-colorpicker/sources/Colorpicker.d.ts",
        "/types/ts-colorpicker/sources/colors.d.ts",
        "/types/ts-colorpicker/sources/helpers/calculations.d.ts",
        "/types/ts-colorpicker/sources/helpers/color.d.ts",
        "/types/ts-colorpicker/sources/locales/en.d.ts",
        "/types/ts-colorpicker/sources/picker.d.ts",
        "/types/ts-colorpicker/sources/types.d.ts",
        "/types/ts-combobox/index.d.ts",
        "/types/ts-combobox/sources/Combobox.d.ts",
        "/types/ts-combobox/sources/helper.d.ts",
        "/types/ts-combobox/sources/keyListener.d.ts",
        "/types/ts-combobox/sources/locales/en.d.ts",
        "/types/ts-combobox/sources/ProCombobox.d.ts",
        "/types/ts-combobox/sources/types.d.ts",
        "/types/ts-common/core.d.ts",
        "/types/ts-common/date.d.ts",
        "/types/ts-common/dom.d.ts",
        "/types/ts-common/events.d.ts",
        "/types/ts-common/FocusManager.d.ts",
        "/types/ts-common/html.d.ts",
        "/types/ts-common/keycodes.d.ts",
        "/types/ts-common/KeyManager.d.ts",
        "/types/ts-common/locale.d.ts",
        "/types/ts-common/polyfills/array.d.ts",
        "/types/ts-common/polyfills/element.d.ts",
        "/types/ts-common/polyfills/math.d.ts",
        "/types/ts-common/polyfills/object.d.ts",
        "/types/ts-common/polyfills/string.d.ts",
        "/types/ts-common/ScrollView.d.ts",
        "/types/ts-common/types.d.ts",
        "/types/ts-common/view.d.ts",
        "/types/ts-data/index.d.ts",
        "/types/ts-data/sources/ajax.d.ts",
        "/types/ts-data/sources/CollectionStore.d.ts",
        "/types/ts-data/sources/datacollection/loader.d.ts",
        "/types/ts-data/sources/datacollection/sort.d.ts",
        "/types/ts-data/sources/datacollection.d.ts",
        "/types/ts-data/sources/dataproxy.d.ts",
        "/types/ts-data/sources/DragManager.d.ts",
        "/types/ts-data/sources/drivers/CsvDriver.d.ts",
        "/types/ts-data/sources/drivers/drivers.d.ts",
        "/types/ts-data/sources/drivers/JsonDriver.d.ts",
        "/types/ts-data/sources/drivers/XMLDriver.d.ts",
        "/types/ts-data/sources/helpers.d.ts",
        "/types/ts-data/sources/lazydataproxy.d.ts",
        "/types/ts-data/sources/selection.d.ts",
        "/types/ts-data/sources/serializers/xml.d.ts",
        "/types/ts-data/sources/treecollection.d.ts",
        "/types/ts-data/sources/types.d.ts",
        "/types/ts-grid/index.d.ts",
        "/types/ts-grid/sources/columnsResizer.d.ts",
        "/types/ts-grid/sources/Exporter.d.ts",
        "/types/ts-grid/sources/Grid.d.ts",
        "/types/ts-grid/sources/helpers/cells.d.ts",
        "/types/ts-grid/sources/helpers/data.d.ts",
        "/types/ts-grid/sources/helpers/keys.d.ts",
        "/types/ts-grid/sources/helpers/main.d.ts",
        "/types/ts-grid/sources/ProGrid.d.ts",
        "/types/ts-grid/sources/Selection.d.ts",
        "/types/ts-grid/sources/types.d.ts",
        "/types/ts-grid/sources/ui/Cells.d.ts",
        "/types/ts-grid/sources/ui/content.d.ts",
        "/types/ts-grid/sources/ui/editors/CheckboxEditor.d.ts",
        "/types/ts-grid/sources/ui/editors/ComboboxEditor.d.ts",
        "/types/ts-grid/sources/ui/editors/DateEditor.d.ts",
        "/types/ts-grid/sources/ui/editors/editors.d.ts",
        "/types/ts-grid/sources/ui/editors/InputEditor.d.ts",
        "/types/ts-grid/sources/ui/editors/SelectEditor.d.ts",
        "/types/ts-grid/sources/ui/editors/TextAreaEditor.d.ts",
        "/types/ts-grid/sources/ui/FixedCols.d.ts",
        "/types/ts-grid/sources/ui/FixedRows.d.ts",
        "/types/ts-grid/sources/ui/render.d.ts",
        "/types/ts-layout/index.d.ts",
        "/types/ts-layout/sources/Cell.d.ts",
        "/types/ts-layout/sources/helpers.d.ts",
        "/types/ts-layout/sources/Layout.d.ts",
        "/types/ts-layout/sources/ProCell.d.ts",
        "/types/ts-layout/sources/ProLayout.d.ts",
        "/types/ts-layout/sources/types.d.ts",
        "/types/ts-list/index.d.ts",
        "/types/ts-list/sources/editors/editors.d.ts",
        "/types/ts-list/sources/editors/InputEditor.d.ts",
        "/types/ts-list/sources/List.d.ts",
        "/types/ts-list/sources/ProList.d.ts",
        "/types/ts-list/sources/Selection.d.ts",
        "/types/ts-list/sources/types.d.ts",
        "/types/ts-message/index.d.ts",
        "/types/ts-message/sources/alert.d.ts",
        "/types/ts-message/sources/common.d.ts",
        "/types/ts-message/sources/confirm.d.ts",
        "/types/ts-message/sources/locales/en.d.ts",
        "/types/ts-message/sources/message.d.ts",
        "/types/ts-message/sources/tooltip.d.ts",
        "/types/ts-message/sources/types.d.ts",
        "/types/ts-navbar/index.d.ts",
        "/types/ts-navbar/sources/elements/button.d.ts",
        "/types/ts-navbar/sources/elements/customHTMLButton.d.ts",
        "/types/ts-navbar/sources/elements/datePicker.d.ts",
        "/types/ts-navbar/sources/elements/helpers.d.ts",
        "/types/ts-navbar/sources/elements/imageButton.d.ts",
        "/types/ts-navbar/sources/elements/input.d.ts",
        "/types/ts-navbar/sources/elements/menuItem.d.ts",
        "/types/ts-navbar/sources/elements/navItem.d.ts",
        "/types/ts-navbar/sources/elements/separator.d.ts",
        "/types/ts-navbar/sources/elements/spacer.d.ts",
        "/types/ts-navbar/sources/elements/title.d.ts",
        "/types/ts-navbar/sources/itemfactory.d.ts",
        "/types/ts-navbar/sources/Navbar.d.ts",
        "/types/ts-navbar/sources/types.d.ts",
        "/types/ts-popup/index.d.ts",
        "/types/ts-popup/sources/Popup.d.ts",
        "/types/ts-popup/sources/types.d.ts",
        "/types/ts-richtext/sources/constants.d.ts",
        "/types/ts-richtext/sources/entry.d.ts",
        "/types/ts-richtext/sources/helpers/buffer.d.ts",
        "/types/ts-richtext/sources/helpers/composition.d.ts",
        "/types/ts-richtext/sources/helpers/link.d.ts",
        "/types/ts-richtext/sources/helpers/markdown.d.ts",
        "/types/ts-richtext/sources/helpers/minimizer.d.ts",
        "/types/ts-richtext/sources/helpers/other.d.ts",
        "/types/ts-richtext/sources/helpers/parser.d.ts",
        "/types/ts-richtext/sources/helpers/scroll.d.ts",
        "/types/ts-richtext/sources/helpers/selection.d.ts",
        "/types/ts-richtext/sources/helpers/serializer.d.ts",
        "/types/ts-richtext/sources/helpers/statistics.d.ts",
        "/types/ts-richtext/sources/helpers/styles.d.ts",
        "/types/ts-richtext/sources/helpers/toolbar.d.ts",
        "/types/ts-richtext/sources/keyhandler.d.ts",
        "/types/ts-richtext/sources/locales/en.d.ts",
        "/types/ts-richtext/sources/Manager.d.ts",
        "/types/ts-richtext/sources/models/Block.d.ts",
        "/types/ts-richtext/sources/models/Editor.d.ts",
        "/types/ts-richtext/sources/models/TextNode.d.ts",
        "/types/ts-richtext/sources/Richtext.d.ts",
        "/types/ts-richtext/sources/SelectionHelper.d.ts",
        "/types/ts-richtext/sources/types.d.ts",
        "/types/ts-slider/index.d.ts",
        "/types/ts-slider/sources/Slider.d.ts",
        "/types/ts-slider/sources/types.d.ts",
        "/types/ts-timepicker/index.d.ts",
        "/types/ts-timepicker/sources/helper.d.ts",
        "/types/ts-timepicker/sources/locales/en.d.ts",
        "/types/ts-timepicker/sources/Timepicker.d.ts",
        "/types/ts-timepicker/sources/types.d.ts",
        "/types/ts-toolbar/index.d.ts",
        "/types/ts-toolbar/sources/ProToolbar.d.ts",
        "/types/ts-toolbar/sources/Toolbar.d.ts"
      ]
    }
  }
};

export default types;
